type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

enum CMMLogLevelGTM {
  EMERGENCY = 0,
  ALERT,
  CRITICAL,
  ERROR,
  WARNING,
  NOTICE,
  INFO,
  DEBUG,
}
interface CMMLogGTM {
  message: string;
  component: string;
  severity: CMMLogLevelGTM;
  program?: string;
}
function cmm_log_data(sendData: CMMLogGTM) {
  var http = new XMLHttpRequest();
  var url = 'https://logs.api.creekmoremarketing.com/logs.php';

  sendData.program = 'Master_GTM';

  if (sendData.message) {
    sendData.message = sendData.message + ' [' + window.location.href + ']';
  }

  http.open('POST', url, true);

  http.setRequestHeader('Content-type', 'application/json');

  http.onreadystatechange = function () {
    if (http.readyState == 4 && http.status == 200) {
      //data sent successfully
    }
  };
  http.send(JSON.stringify(sendData));
}

/*Wait for jQuery to load*/
var cmmDeferStartTime = new Date().getTime();
function deferJQuery(func /**/) {
  var variadic_args = Array.prototype.slice.call(arguments, 1);
  if (window.jQuery) {
    func.apply(this, variadic_args);
  } else {
    if (
      cmmDeferStartTime &&
      new Date().getTime() - cmmDeferStartTime > 3 * 1000
    ) {
      console.warn(
        'CMM: jQuery unavailable or loading slowly; may result in un-recorded scroll tracking events.',
      );
      cmmDeferStartTime = null;
    }
    setTimeout(function () {
      variadic_args.unshift(func);
      deferJQuery.apply(null, variadic_args);
    }, 50);
  }
}

var cmmRlPhoneConversionCount = 0;
/**
 * Checks if this is firing a Google Ads call conversion when using RL
 */
function checkRLGoogleAdsPhoneReplacement(...items: any[]): boolean {
  if (!(window as any).rl_widget_cfg) {
    return false;
  }

  if (!items[0]) {
    return false;
  }

  const conversionOptions = items[0][2];
  if (
    typeof conversionOptions !== 'object' ||
    !conversionOptions.phone_conversion_number ||
    conversionOptions.cmm_platform
  ) {
    return false;
  }

  cmmRlPhoneConversionCount++;
  if (cmmRlPhoneConversionCount <= 1) {
    // run for no matter how many conversions
    // return false;
  }

  const conversionTag = items[0][1];

  cmm_log_data({
    message: `Conversion Error: Replacing RL number with Google Ads number [${conversionTag}/${conversionOptions.phone_conversion_number}]`,
    component: 'RL_Scripts',
    severity: CMMLogLevelGTM.ERROR,
  });

  return true;
}

// Fire event when items added to dataLayer
type DataLayerPushEvent = Event & {
  detail: {
    dataLayerObject: Record<string | number, any>;
  };
};
(window.dataLayer as any).realPush = dataLayer.push;
dataLayer.push = function (...items: object[]) {
  checkRLGoogleAdsPhoneReplacement(...items);

  let pushResponse = (window.dataLayer as any).realPush(...items);

  if (items) {
    const pushEvent = new CustomEvent('datalayerpush', {
      detail: {
        dataLayerObject: items[0],
      },
    });

    window.dispatchEvent(pushEvent);
  }

  return pushResponse;
};

type CMM_WIX_PAGEVIEW_EVENT = {
  pageContainer?: HTMLElement;
};
declare var Shopify: any;
let CMM_GENERATOR = null;
const CMM_GENERATOR_WIX = 'Wix.com Website Builder';
const CMM_GENERATOR_SHOPIFY = 'Shopify';
const CMM_GENERATOR_INTERNAL = 'Internal';
function cmmGetGenerator(): string {
  if (CMM_GENERATOR === null) {
    const generator = document.querySelector('meta[name="generator"]');
    if (!generator) {
      if (document.body.id === 'dmRoot') {
        CMM_GENERATOR = CMM_GENERATOR_INTERNAL;
      } else if (window.Shopify) {
        CMM_GENERATOR = CMM_GENERATOR_SHOPIFY;
      } else {
        CMM_GENERATOR = '';
      }
    } else {
      CMM_GENERATOR = generator.getAttribute('content');
    }
  }

  if (CMM_GENERATOR === CMM_GENERATOR_WIX) {
    // listen for Wix page changes
    cmmLoadWix().then((_) => {
      wixDevelopersAnalytics.register('cmm', (eventName: string, data: any) => {
        if (eventName == 'PageView') {
          strPath = cmmGetPath();
          window.dispatchEvent(
            new CustomEvent<CMM_WIX_PAGEVIEW_EVENT>('cmm-wix-pageview', {
              detail: {
                pageContainer: document.querySelector('#SITE_PAGES .wixui-page')
                  ?.parentElement,
              },
            }),
          );
        }
      });
    });
  }

  return CMM_GENERATOR;
}
cmmGetGenerator();

type CMMGA4Config = {
  trackingID: string;
  config: {
    send_page_view?: boolean;
  };
};
function cmmGetDataLayerGA4Config(
  trackingID: string = '',
): CMMGA4Config | null {
  // find the first config event. If a tracking ID is provided, find that config event
  const analytics_config = dataLayer.find((data) => {
    if (data[0] !== 'config') return false;
    if (trackingID && data[1] !== trackingID) return false;
    return true;
  });
  if (
    !analytics_config ||
    (!analytics_config[1]?.startsWith('G-') &&
      !analytics_config[1]?.startsWith('GT-'))
  ) {
    return null;
  }

  return {
    trackingID: analytics_config[1],
    config: analytics_config[2] ?? {},
  };
}
let CMM_IS_ANALYTICS_VERSION_4 = false;
if (
  window.cmm_gtm_ua_code?.startsWith('G-') ||
  window.cmm_gtm_ua_code?.startsWith('GT-')
) {
  CMM_IS_ANALYTICS_VERSION_4 = true;
} else if (!window.cmm_gtm_ua_code) {
  if (cmmGetDataLayerGA4Config()) {
    CMM_IS_ANALYTICS_VERSION_4 = true;
  }
}

function cmmObfuscateEmail(email: string): string {
  const emailParts = email.split('@');
  if (emailParts.length !== 2) {
    return '';
  }

  const nameFirstCh = emailParts[0].slice(0, 1);
  const nameLastCh = emailParts[0].slice(-1);
  const domain = emailParts[1].slice(0, 1);
  const lastDot = emailParts[1].lastIndexOf('.');
  const tld = emailParts[1].slice(lastDot + 1);

  return `${nameFirstCh}********${nameLastCh}@${domain}*****.${tld}`;
}

function cmmSendGTMData(
  event: string,
  action: string,
  label: string,
  category?: string,
) {
  let data: Record<string, string> = {
    event: event,
    action: action,
    label: label,
  };

  if (category !== null) {
    data['category'] = category;
  }

  window.dataLayer.push(data);
}

var cmmFirstReady = true;
function cmmInitDmPageChange() {
  if (window.dmAPI && window.dmAPI.runOnReady) {
    dmAPI.runOnReady('cmm', () => {
      if (!cmmFirstReady) {
        cmmPageChangeFunctions.forEach((func) => func());
      }
      cmmFirstReady = false;
    });
  } else {
    setTimeout(cmmInitDmPageChange, 10);
  }
}
var cmmPageChangeFunctions = [];
if (cmmGetGenerator() === CMM_GENERATOR_INTERNAL) {
  cmmInitDmPageChange();
} else {
  var cmmPushState = history.pushState;
  history.pushState = function () {
    cmmPushState.apply(history, arguments);
    cmmPageChangeFunctions.forEach((func) => func());
  };
}
if (!CMM_IS_ANALYTICS_VERSION_4) {
  cmmPageChangeFunctions.push(() => {
    cmmSendGTMData('cmm.pageview-ajax', 'page-loaded', document.location.href);
  });
}

var cmmScrollTrackingPercents: Record<number, boolean> = {};
function cmmScrollTracking(percents: number[]) {
  // setup which percentages have been reached
  percents.forEach((percent) => (cmmScrollTrackingPercents[percent] = false));

  // listen for percentage events
  window.addEventListener('scroll', function () {
    var s = window.scrollY;
    var d =
      cmmGetGenerator() == CMM_GENERATOR_WIX
        ? document.querySelector('#SITE_CONTAINER').clientHeight
        : document.body.clientHeight;
    var c = window.innerHeight;

    var scrollPercent = (s / (d - c)) * 100;

    percents.forEach((percent) => {
      if (scrollPercent >= percent && !cmmScrollTrackingPercents[percent]) {
        if (CMM_IS_ANALYTICS_VERSION_4) {
          cmmSendEventData(null, null, 'scroll', {
            percent_scrolled: percent,
          });
        } else {
          cmmSendGTMData(
            'cmm.scroll-event',
            percent + '',
            document.location.href,
          );
        }

        // set that this scroll depth has been reached
        cmmScrollTrackingPercents[percent] = true;
      }
    });
  });
}
if (!CMM_IS_ANALYTICS_VERSION_4) {
  cmmScrollTracking([25, 50, 75, 100]);
}

type GA4EventParameters = Record<string, string | number>;
function cmmSendEventData(
  action: string = '',
  label: string = '',
  eventName: string = 'cmm.custom-event',
  ga4Parameters?: GA4EventParameters,
  category?: string,
) {
  if (CMM_IS_ANALYTICS_VERSION_4) {
    if (!window.gtag) {
      window.gtag =
        window.gtag ||
        function () {
          dataLayer.push(arguments);
        };
    }

    let data: GA4EventParameters = {};

    if (action) {
      data['event_action'] = action;
    }

    if (label) {
      data['event_label'] = label;
    }

    if (category) {
      data['event_category'] = category;
    }

    if (ga4Parameters) {
      data = Object.assign(data, ga4Parameters);
    }

    gtag('event', eventName, data);

    // TODO: Remove after GA4 dashboard change
    if (eventName === 'scroll') return; // exit to not track scroll events
    data['event_action'] = data['event_action'] ?? eventName;
    data['event_label'] = data['event_label'] ?? window.location.href;
    gtag('event', 'cmm_event', data);
  } else {
    cmmSendGTMData(eventName, action, label);
  }
}

type EventTrigger = {
  /** Which elements to fire on */
  selector: string | (HTMLElement | Document)[];
  /** Element self/parent if needed */
  closest?: string;
  /** User interaction to fire on */
  event?: string;

  // Data sent to Analytics
  category?: string;
  /** @default `event` parameter, which defaults to `click` */
  action?: string | ((elem: HTMLElement) => string);
  label?: string | ((elem: HTMLElement) => string);
  /** Less than 40 characters long */
  ga4Event?: string;
  /** Less than 40 characters long for property
   * and less than 100 for value. */
  ga4Parameters?: GA4EventParameters;

  // How to handle the event
  errorType?: string;
  autoRefresh?: boolean;
  /** Only check on specific strPaths */
  pagePaths?: string[];
  condition?: boolean | ((e: Event) => boolean);
};

function _cmmHandleTrigger(trigger: EventTrigger, index: number) {
  if (!document.querySelector) {
    console.warn("CMM: This browser doesn't support document.querySelector.");
    return;
  }

  if (!trigger.errorType) trigger.errorType = 'error';

  if (trigger.pagePaths && !trigger.pagePaths.includes(strPath)) {
    cmmCheckInternal().then((isInternal) => {
      if (!isInternal) return;
      console[trigger.errorType](
        'Creekmore Marketing: Event trigger (' +
          (index + 1) +
          ') only set to load on pages: ' +
          trigger.pagePaths.join(', '),
      );
    });
    return;
  }

  if (!trigger.selector && trigger.errorType != 'none') {
    cmmCheckInternal().then((isInternal) => {
      if (!isInternal) return;
      console[trigger.errorType](
        'Creekmore Marketing: No selector set for event tracking trigger: ' +
          (index + 1),
      );
    });
    return;
  }

  if (!trigger.action && trigger.errorType != 'none') {
    cmmCheckInternal().then((isInternal) => {
      if (!isInternal) return;
      console[trigger.errorType](
        'Creekmore Marketing: No action set for event tracking trigger: ' +
          (index + 1),
      );
    });
    return;
  }

  if (!trigger.event) trigger.event = 'click';

  const targetElements = Array.isArray(trigger.selector)
    ? trigger.selector
    : [...document.querySelectorAll<HTMLElement>(trigger.selector)];

  // exit if no elements were found
  // autorefresh if set however
  if (targetElements.length === 0) {
    if (trigger.autoRefresh) {
      setTimeout(function () {
        _cmmHandleTrigger(trigger, index);
      }, 50);
    } else if (trigger.errorType != 'none') {
      cmmCheckInternal().then((isInternal) => {
        if (!isInternal) return;
        console[trigger.errorType](
          'Creekmore Marketing: No elements were found with the selector: ' +
            trigger.selector,
        );
      });
    }

    return;
  }

  targetElements.forEach((elem) => {
    elem.addEventListener(trigger.event, function (ev: Event) {
      //don't fire if the condition isn't met
      if (typeof trigger.condition === 'boolean' && !trigger.condition) return;
      else if (
        typeof trigger.condition === 'function' &&
        !trigger.condition(ev)
      )
        return;

      // get the event target element
      // exit if the closest target element isn't found
      let targetElement: HTMLElement = ev.currentTarget as HTMLElement;
      if (trigger.closest) {
        targetElement = (ev.target as HTMLElement).closest(trigger.closest);
        if (!targetElement) {
          return;
        }
      }

      let action: string;
      if (typeof trigger.action === 'function') {
        action = trigger.action(targetElement);
      } else {
        action = trigger.action;
      }
      if (!action) {
        action = targetElement.dataset.cmmEvAction ?? action;
      }
      if (targetElement.dataset.cmmEvActionBody !== undefined) {
        // action = action.replace(/Banner Link( - )?(.*)/g, '$2$1') + 'Body';
      }

      let label: string;
      if (typeof trigger.label === 'function') {
        label = trigger.label(targetElement);
      } else {
        label = trigger.label;
      }
      if (!label) {
        label =
          targetElement.dataset.cmmEvLabel ||
          (targetElement as HTMLAnchorElement).href ||
          targetElement.textContent.trim() ||
          targetElement.title ||
          targetElement.ariaLabel ||
          targetElement.innerHTML ||
          (typeof trigger.selector === 'string' ? trigger.selector : '');
      }

      if (CMM_IS_ANALYTICS_VERSION_4) {
        cmmSendEventData(
          action,
          label,
          trigger.ga4Event,
          trigger.ga4Parameters,
          trigger.category,
        );
      } else {
        cmmSendEventData(action, label, trigger.category);
      }
    });
  });
}

//Max Length for action and label: https://developers.google.com/analytics/devguides/collection/protocol/v1/parameters#ea
//Papertrail logging?
declare var cmmSetupEventTracking: (triggerArray: EventTrigger[]) => void;
window.cmmSetupEventTracking =
  window.cmmSetupEventTracking ||
  function (triggerArray: EventTrigger[]) {
    //trigger options
    /*
  selector: "SELECTOR", (required) (jQuery selector: https://api.jquery.com/category/selectors/)
  action: "ACTION", (required) (user action(s) and text in Google Analytics; e.g. "CTA - Banner Link")
  category: "CATEGORY" (optional) (event category like "CMM Goal Event" or "CMM Tracking Event")
  event: "TYPE", (optional) (e.g. 'hover', 'click', or multiple like 'hover mouseover'; will default to 'click')
  label: "LABEL", (optional) (will default to the page URL)
  errorType: "STRING", (optional) ("error", "warn", "none") (defaults to "error");
  autoRefresh: true/false (optional) (keep refreshing the selector until the element(s) is found)
  */

    if (
      document.readyState === 'complete' ||
      (document.readyState as any) === 'loaded' ||
      document.readyState === 'interactive'
    ) {
      triggerArray.forEach(_cmmHandleTrigger);
    } else {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          triggerArray.forEach(_cmmHandleTrigger);
        },
        false,
      );
    }
  };

function cmmGetPath(path: string = ''): string {
  if (path == '') {
    path = window.location.pathname;
  }

  return path[path.length - 1] == '/' ? path.slice(1, -1) : path.substring(1);
}

/** @deprecated use `cmmRunOnPath` function */
var strPath = cmmGetPath();

function _cmmRunPathCheck(
  paths: (string | RegExp)[] | null,
  currentPath: string,
): boolean {
  if (paths === null) {
    return true;
  }

  let currentlyOnPath = paths.some((path) => {
    if (typeof path === 'string') {
      return path === currentPath;
    } else {
      return path.test(currentPath);
    }
  });

  if (!currentlyOnPath) {
    return false;
  }

  return true;
}

type RunOnPathsCallback = (currentPath: string, initialLoad: boolean) => void;

/**
 * Set the path(s) that the function should run on. You can set `path` to null for all paths
 *
 * @param funcOnPath Runs when the page is on the path
 * @param funcOffPath Runs when the page is not on the path
 * @param runInitial If the code should run when first loaded; helpful for
 *   when the initial script is different
 */
function cmmRunOnPaths(
  paths: (string | RegExp)[] | null,
  funcOnPath: RunOnPathsCallback,
  funcOffPath?: RunOnPathsCallback,
  runInitial: boolean = true,
): void {
  function runPathCheck(currentPath: string, initialLoad: boolean) {
    if (paths !== null) {
      if (!_cmmRunPathCheck(paths, currentPath)) {
        // run if not currently on the path(s)
        if (funcOffPath) {
          funcOffPath(currentPath, initialLoad);
        }

        return;
      }
    }

    funcOnPath(currentPath, initialLoad);
  }

  // run for the first time if needed
  if (runInitial) {
    runPathCheck(cmmGetPath(), true);
  }

  // _cmmRunOnPageChange.push(runPathCheck);
}

/**
 * Setup Wix functions after the frontend JS libraries have loaded
 */
function cmmLoadWix(): Promise<typeof wixDevelopersAnalytics> {
  return new Promise((resolve, reject) => {
    var afterWixDeveloperAnalytics = () => {
      if (window.wixDevelopersAnalytics) {
        resolve(wixDevelopersAnalytics);
      } else {
        setTimeout(afterWixDeveloperAnalytics, 50);
      }
    };
    afterWixDeveloperAnalytics();
  });
}

//TODO: Install @types/facebook-pixel later
type FacebookPixel = (
  eventType: string,
  InitialAppId: string,
  parameters?: any,
) => void;
declare var fbq: FacebookPixel;
function cmmWaitForFacebook(): Promise<FacebookPixel> {
  return new Promise<FacebookPixel>((resolve, reject) => {
    var afterFBQLoaded = () => {
      if (window.fbq) {
        resolve(window.fbq);
      } else {
        setTimeout(afterFBQLoaded, 50);
      }
    };
    afterFBQLoaded();
  });
}

var loadFacebookTrackingPromises = 1;
function loadFacebookTracking(trackingID: string): Promise<FacebookPixel> {
  return new Promise<FacebookPixel>((resolve, reject) => {
    let promiseCallback =
      'resolveFacebookTrackingPromise' + loadFacebookTrackingPromises;
    window[promiseCallback] = () => resolve((window as any).fbq);
    loadFacebookTrackingPromises++;

    var scrFacebook = document.createElement('script');
    scrFacebook.type = 'text/javascript';
    scrFacebook.text =
      "!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', '" +
      trackingID +
      "');fbq('track', 'PageView');";
    scrFacebook.text += promiseCallback + '();';
    document.head.appendChild(scrFacebook);

    // Hid noscript since this script wouldn't run if noscript was enabled
    // var noscrFacebook = document.createElement("noscript");
    // var imgFacebook = document.createElement("img");
    // imgFacebook.width = 1;
    // imgFacebook.height = 1;
    // imgFacebook.src = "https://www.facebook.com/tr?id=" + trackingID + "&ev=PageView&noscript=1";
    // noscrFacebook.appendChild(imgFacebook);
    // document.head.appendChild(noscrFacebook);
  });
}

/* Yelp Window Elements */
declare var adroll_adv_id: string;
declare var adroll_pix_id: string;
declare var adroll_version: string;
declare var __adroll_loaded: boolean;
declare var adroll: YelpAdroll;
type YelpAdroll = any[] & {
  f?: string[];
  setProperties?: (...args: any[]) => any;
  identify?: (...args: any[]) => any;
  track?: (...args: any[]) => any;
};
var loadYelpTrackingPromises = 1;
function loadYelpTracking(
  yelp_adv_id: string,
  yelp_pix_id: string,
  yelp_version: string = '2.0',
): Promise<YelpAdroll> {
  return new Promise<YelpAdroll>((resolve, reject) => {
    let promiseCallback =
      'resolveYelpTrackingPromise' + loadYelpTrackingPromises;
    window[promiseCallback] = () => resolve(window.adroll);
    loadYelpTrackingPromises++;

    adroll_adv_id = yelp_adv_id;
    adroll_pix_id = yelp_pix_id;
    adroll_version = yelp_version;

    var scrYelp = document.createElement('script');
    scrYelp.type = 'text/javascript';
    scrYelp.text = `(function(w, d, e, o, a) { w.__adroll_loaded = true; w.adroll = w.adroll || []; w.adroll.f = [ 'setProperties', 'identify', 'track' ]; var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id + "/roundtrip.js"; for (a = 0; a < w.adroll.f.length; a++) { w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) { return function() { w.adroll.push([ n, arguments ]) } })(w.adroll.f[a]) } e = d.createElement('script'); o = d.getElementsByTagName('script')[0]; e.async = 1; e.src = roundtripUrl; o.parentNode.insertBefore(e, o); })(window, document);`;
    scrYelp.text += 'adroll.track("pageView");';
    scrYelp.text += promiseCallback + '();';
    document.head.appendChild(scrYelp);
  });
}

declare var ndp: NextdoorPixel;
type NextdoorPixel = (eventType: string, ...parameters: any[]) => void;
var loadNextdoorTrackingPromises = 1;
function loadNextdoorTracking(trackingID: string): Promise<NextdoorPixel> {
  return new Promise<NextdoorPixel>((resolve, reject) => {
    let promiseCallback =
      'resolveNextdoorTrackingPromise' + loadNextdoorTrackingPromises;
    window[promiseCallback] = () => resolve(window.ndp);
    loadNextdoorTrackingPromises++;

    var scrNextdoor = document.createElement('script');
    scrNextdoor.type = 'text/javascript';
    scrNextdoor.text =
      "(function(win, doc, sdk_url){if(win.ndp) return;var tr=win.ndp=function(){tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);};tr.queue = [];var s='script';var new_script_section=doc.createElement(s);new_script_section.async=!0;new_script_section.src=sdk_url;var insert_pos=doc.getElementsByTagName(s)[0];insert_pos.parentNode.insertBefore(new_script_section, insert_pos);})(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');";
    scrNextdoor.text += `ndp('init','${trackingID}', {});`;
    scrNextdoor.text += `ndp('track','PAGE_VIEW');`;
    scrNextdoor.text += promiseCallback + '();';
    document.head.appendChild(scrNextdoor);
  });
}

function loadClarityTracking(clarity_id: string) {
  var srcClarity = document.createElement('script');
  srcClarity.type = 'text/javascript';
  srcClarity.text = `(function(c,l,a,r,i,t,y){c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);})(window, document, "clarity", "script", "${clarity_id}");`;
  document.head.appendChild(srcClarity);
}

function loadClickCeaseTracking() {
  var script = document.createElement('script');
  script.async = true;
  script.type = 'text/javascript';
  var target = 'https://www.clickcease.com/monitor/stat.js';
  script.src = target;
  var elem = document.head;
  elem.appendChild(script);
}

/**
 *
 */
type PageMetaData = {
  description?: string;
  desc?: string;
  d?: string;
  title?: string;
  t?: string;
  image?: string;
  i?: string;
};
var cmmAddedMetadataListener = false;
function cmmUpdateMetadata(pageData: { [path: string]: PageMetaData }) {
  if (window.dmAPI && !cmmAddedMetadataListener) {
    dmAPI.runOnReady('cmm', function (e) {
      strPath = cmmGetPath();
      cmmUpdateMetadata(pageData);
    });
    cmmAddedMetadataListener = true;
    return;
  } else if (
    cmmGetGenerator() == CMM_GENERATOR_WIX &&
    !cmmAddedMetadataListener
  ) {
    window.addEventListener('cmm-wix-pageview', (e) => {
      cmmUpdateMetadata(pageData);
    });

    cmmAddedMetadataListener = true;
  }

  let metadata = pageData[strPath];

  // check if pageData using query parameter
  if (!metadata) {
    const currentParams = new URL(location.href);
    const metadataKey = Object.keys(pageData).find((pathKey) => {
      const parts = pathKey.split('?');
      if (parts[0] !== strPath) return false;

      const params = parts[1].split('&');
      const hasRequiredParams = params.every((p) => {
        const paramParts = p.split('=');
        const paramValue = decodeURIComponent(paramParts[1] ?? '').replaceAll(
          '+',
          ' ',
        );
        return currentParams.searchParams.get(paramParts[0]) === paramValue;
      });

      return hasRequiredParams;
    });

    metadata = pageData[metadataKey];
  }

  if (!metadata) {
    return;
  }

  let descMetaTag = null;
  let ogTitle = null;
  let ogDesc = null;
  let ogImage = null;

  let metaTags = document.getElementsByTagName('meta');
  if (
    metadata.description ||
    metadata.desc ||
    metadata.d ||
    metadata.title ||
    metadata.t
  ) {
    for (let i = 0; i < metaTags.length; i++) {
      if (metaTags[i].name == 'description') {
        descMetaTag = metaTags[i];
      }

      let metaProperty = metaTags[i].getAttribute('property');
      if (!metaProperty) metaProperty = '';
      if (metaProperty == 'og:description') {
        ogDesc = metaTags[i];
      } else if (metaProperty == 'og:title') {
        ogTitle = metaTags[i];
      } else if (metaProperty == 'og:image') {
        ogImage = metaTags[i];
      }
    }
  }

  if (metadata.description || metadata.desc || metadata.d) {
    if (!descMetaTag) {
      descMetaTag = document.createElement('meta');
      descMetaTag.name = 'description';
      document.head.append(descMetaTag);
    }
    descMetaTag.content = metadata.description || metadata.desc || metadata.d;

    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.append(ogDesc);
    }
    ogDesc.content = metadata.description || metadata.desc || metadata.d;
  }

  if (metadata.title || metadata.t) {
    let titleTag = document.getElementsByTagName('title')[0];
    titleTag.innerText = metadata.title || metadata.t;
    document.title = metadata.title || metadata.t;

    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.append(ogTitle);
    }
    ogTitle.content = metadata.title || metadata.t;
  }

  if (metadata.image || metadata.i) {
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.append(ogImage);
    }
    ogImage.content = metadata.image || metadata.i;
  }
}

/**
 * Generates caption text from alt text
 */
function cmmGenerateHDCaptionText(imageElem: HTMLElement): string {
  let captionText = '';
  if (imageElem) {
    let textData = '';
    if (imageElem.getAttribute('alt')) {
      textData = imageElem.getAttribute('alt');
    } else {
      textData = imageElem.textContent;
    }

    captionText = textData;
    if (textData && textData !== '[[NO DATA]]') {
      const stopIndex = textData.search(/((-|–|—|\|)|(\s(for|near|in)\s))/gi);
      if (stopIndex > -1) {
        captionText = textData.substr(0, stopIndex).trim();
      }
    }
  }

  return captionText;
}

declare var cmm_is_hd_waiver_site: boolean;
var cmmHDStylesAdded = false;
/**
 * Adds Hunter Douglas copyright text to images
 */
function cmmApplyHDCopyrights() {
  // Leave if not an HD waiver site
  if (!window.cmm_is_hd_waiver_site) return;

  const generator = cmmGetGenerator();

  if (generator == CMM_GENERATOR_INTERNAL) {
    const isHomePage =
      window.location.pathname === '/' || window.location.pathname === '';

    if (!cmmHDStylesAdded) {
      let styles = document.createElement('style');
      styles.textContent = `.blogImgLink {
          position: relative;
        }
        .cmm-hd-image-copyright {
          text-align: center;
          background: #000;
          color: #fff;
          padding: 2px 8px;
          text-overflow: ellipsis;
          white-space: pre;
          overflow: hidden;
        }
        .blogImgLink .cmm-hd-image-copyright {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          font-size: .9rem;
        }
        .imageWidget .cmm-hd-image-copyright {
          
        }
        .hasBackgroundOverlay .cmm-hd-image-copyright {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .hasBackgroundOverlay .cmm-hd-image-copyright.cmm-home-copyright {
          bottom: 15.3%;
          right: 40px;
        }`;
      document.head.appendChild(styles);
      cmmHDStylesAdded = true;
    }

    let doneHomeBanner = false;
    document
      .querySelectorAll<HTMLElement>(
        '.mainBlog .blogImgLink, .blog-post-row .imageWidget, .hasBackgroundOverlay',
      )
      .forEach((elem) => {
        let imageData = elem.querySelector<HTMLElement>('img, .widget-dd7d15');

        //try to get the image on a page that matches the background
        if (!imageData && elem.classList.contains('hasBackgroundOverlay')) {
          let backgroundURL = elem.style.backgroundImage.replace(
            /^url|["\(\)]/gi,
            '',
          );
          imageData = document.querySelector(
            'img[data-dm-image-path="' + backgroundURL + '"]',
          );
        }

        let captionText = cmmGenerateHDCaptionText(imageData);
        if (captionText) {
          let copyrightNode = document.createElement('div');

          let doHomeBanner = false;
          if (
            isHomePage &&
            !doneHomeBanner &&
            elem.classList.contains('hasBackgroundOverlay')
          ) {
            doHomeBanner = true;
            doneHomeBanner = true;
          }

          if (elem.classList.contains('blogImgLink')) {
            elem.style.display = 'block';
          }

          copyrightNode.className =
            'cmm-hd-image-copyright' +
            (doHomeBanner ? ' cmm-home-copyright' : '');
          copyrightNode.textContent = captionText;

          let customBottom =
            imageData.firstElementChild?.attributes['data-bottom-position']
              ?.value;
          if (customBottom || customBottom === '0') {
            copyrightNode.style.bottom = customBottom + 'px';
          }
          let customRight =
            imageData.firstElementChild?.attributes['data-right-position']
              ?.value;
          if (customRight || customRight === '0') {
            copyrightNode.style.right = customRight + 'px';
          }

          elem.appendChild(copyrightNode);
        }
      });
  }
}
cmmApplyHDCopyrights();
cmmPageChangeFunctions.push(() => {
  cmmApplyHDCopyrights();
});

var cmmUserInteracted = window.cmmUserInteracted || false;
function cmmSetupSingleInteractionListener(
  eventType: string,
  callback: Function,
) {
  window.addEventListener(
    eventType,
    () => {
      if (!cmmUserInteracted) {
        cmmUserInteracted = true;
        callback();
      }
    },
    { once: true },
  );
}
function cmmFireAfterUserInteraction(callback: Function) {
  if (!window.cmmUserInteracted) {
    let eventTypes = ['scroll', 'click', 'tap', 'focus', 'mouseover'];
    eventTypes.forEach((eventType) => {
      cmmSetupSingleInteractionListener(eventType, callback);
    });
  } else {
    callback();
  }
}

let CMM_IS_INTERNAL: Promise<boolean> = null;
/**
 * Wrapper for localStorage data on assets.creekmoremarketing.com
 */
function cmmCheckInternal(is_internal: boolean = false): Promise<boolean> {
  if (CMM_IS_INTERNAL == null) {
    CMM_IS_INTERNAL = new Promise<boolean>((resolve, reject) => {
      if (window.location.search.indexOf('cmm-external') > -1) {
        resolve(false);
        return;
      }

      var CMM_MESSAGE_WINDOW = document.createElement('iframe');
      CMM_MESSAGE_WINDOW.style.display = 'none';
      window.addEventListener(
        'message',
        (event) => {
          if (event.origin !== 'https://assets.creekmoremarketing.com') {
            //message was for some other system
            return;
          }

          let message = event.data;
          if (message == 'true') {
            resolve(true);
          } else {
            resolve(false);
          }
        },
        false,
      );
      CMM_MESSAGE_WINDOW.onload = function () {
        if (is_internal) {
          resolve(true);
          CMM_MESSAGE_WINDOW.contentWindow.postMessage(
            'is_internal',
            'https://assets.creekmoremarketing.com',
          );
        } else {
          CMM_MESSAGE_WINDOW.contentWindow.postMessage(
            'check',
            'https://assets.creekmoremarketing.com',
          );
        }
      };
      CMM_MESSAGE_WINDOW.onerror = function () {
        reject();
      };
      CMM_MESSAGE_WINDOW.src =
        'https://assets.creekmoremarketing.com/cmm-assets-localstorage.html';
      document.body.appendChild(CMM_MESSAGE_WINDOW);
    });
  }

  return CMM_IS_INTERNAL;
}
cmmCheckInternal(window.location.search.indexOf('cmm-internal') > -1).then(
  (isInternal) => {
    if (isInternal) {
      console.warn('CMM: Internal Traffic User ');

      document.body.classList.add('cmm-internal-user');
    }
  },
);
function cmmIfInternal(func: () => void) {
  return cmmCheckInternal().then((isInternal) => {
    if (!isInternal) return;
    func();
  });
}

/**
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 *
 * START HD SCRIPT COPYING - CONVERT TO SCRIPT GENERATION FUNCTION
 *
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 */

/**
 * Device type array
 */
type DeviceArray = ('desktop' | 'laptop' | 'tablet' | 'mobile')[];
/**
 * Adds classes to show or hide element on differtent devices
 */
function cmmShowDeviceClassList(devices: DeviceArray): string[] {
  const deviceListShowClass = {
    'true,true,true,true': [],
    'true,true,true,false': ['cmm-show-for-medium-up'],
    'true,true,false,true': ['cmm-hide-for-medium'],
    'true,true,false,false': ['cmm-show-for-large-up'],
    'true,false,true,true': ['cmm-hide-for-large'],
    'true,false,true,false': ['cmm-hide-for-large', 'cmm-hide-for-small'],
    'true,false,false,true': ['cmm-hide-for-large', 'cmm-hide-for-medium'],
    'true,false,false,false': ['cmm-hide-for-large-down'],
    'false,true,true,true': ['cmm-hide-for-xlarge'],
    'false,true,true,false': ['cmm-hide-for-xlarge', 'cmm-hide-for-small'],
    'false,true,false,true': ['cmm-hide-for-xlarge', 'cmm-hide-for-medium'],
    'false,true,false,false': ['cmm-show-for-large'],
    'false,false,true,true': ['cmm-hide-for-large-up'],
    'false,false,true,false': ['cmm-show-for-medium'],
    'false,false,false,true': ['cmm-show-for-small'],
    'false,false,false,false': ['cmm-hide-for-small-up'],
  };

  const deviceShowArray = [
    devices.includes('desktop'),
    devices.includes('laptop'),
    devices.includes('tablet'),
    devices.includes('mobile'),
  ];

  return deviceListShowClass[deviceShowArray.join(',')];
}

/**
 * Turns the button text to the phone number
 */
function cmmTextToNum(elem: HTMLElement) {
  elem.classList.add('cmm-text-to-num');
  const numText = elem.dataset.numText;

  const buttonTitle = elem.querySelector('.button-title');
  if (!buttonTitle) return;
  buttonTitle.textContent = numText;
}

/**
 * Turns the button text back into the original content
 */
function cmmTextFromNum(elem: HTMLElement) {
  if (!elem.classList.contains('cmm-text-to-num')) {
    return;
  }

  elem.classList.remove('cmm-text-to-num');
  const originalText = elem.dataset.oText;
  const buttonTitle = elem.querySelector('.button-title');
  if (!buttonTitle) return;

  buttonTitle.textContent = originalText;
}

const CMM_ICON = {
  phone:
    '<svg class="cmm-phone" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70"><g><path d="M18.8,51.4C36.2,68.8,50.3,70,54.3,70C60.8,70,70,61.7,70,59.5v-4.2c0-1-0.7-1.8-1.7-2.2l-16.7-5.3 c-0.8-0.3-1.7,0-2.3,0.5l-6,6.3c-0.7,0.7-1.8,0.8-2.7,0.3c-2.5-1.5-8-4.8-14.3-11.3C20,37.4,16.5,31.9,15,29.4 c-0.5-0.8-0.3-2,0.3-2.7l6.2-6.2c0.7-0.7,0.8-1.5,0.5-2.3L16.7,1.7c-0.3-1-1.2-1.7-2.2-1.7h-4.2C8.3,0.3,0,9.6,0,16 C0,19.8,1.3,33.9,18.8,51.4L18.8,51.4z"/></g></svg>',
  'map-pin':
    '<svg class="cmm-map-pin" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" class=""></path></svg>',
  email:
    '<svg class="cmm-email" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 19.77"><path d="M11.83,17.1,1.09,24.88H28.91L18.17,17.1l-2,1.81a1.85,1.85,0,0,1-2.44,0Z" transform="translate(0 -5.12)"/><path d="M.14,24.28,11,16.38,0,6.19V23.74a1.09,1.09,0,0,0,.14.54Z" transform="translate(0 -5.12)"/><path d="M.56,5.28,12.15,16a.86.86,0,0,1,.14.13h0l2.19,2a.76.76,0,0,0,.51.19.78.78,0,0,0,.51-.19L29.44,5.28a1.15,1.15,0,0,0-.58-.16H1.14a1.15,1.15,0,0,0-.58.16Z" transform="translate(0 -5.12)"/><path d="M30,6.19,19,16.38l10.91,7.9a1.09,1.09,0,0,0,.14-.54V6.19Z" transform="translate(0 -5.12)"/></svg>',
  house:
    '<svg class="cmm-house" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path d="M29.46,12.85,24.37,8.17V2.78a.52.52,0,0,0-.46-.56H21.09a.53.53,0,0,0-.47.56v2L15.86.35a1.23,1.23,0,0,0-1.72,0L.54,12.85A1.87,1.87,0,0,0,.3,15.18a1.26,1.26,0,0,0,2,.3l12-11.06a1.17,1.17,0,0,1,.7-.36,1.17,1.17,0,0,1,.7.36l12,11.06a1.3,1.3,0,0,0,.86.35,1.32,1.32,0,0,0,1.11-.65A1.87,1.87,0,0,0,29.46,12.85Z" transform="translate(0)"/><path d="M25.88,15.84,15.37,6.18a.55.55,0,0,0-.74,0L4.12,15.84a1.41,1.41,0,0,0-.37.9v12.7a.52.52,0,0,0,.47.56h7.5a.52.52,0,0,0,.47-.56V20.56a.52.52,0,0,1,.47-.56h4.68a.52.52,0,0,1,.47.56v8.88a.52.52,0,0,0,.47.56h7.5a.52.52,0,0,0,.47-.56V16.74A1.41,1.41,0,0,0,25.88,15.84Z"/></svg>',
  sms: '<svg class="cmm-sms" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 87.01"><path d="M89.76,6H10.47A10.39,10.39,0,0,0,0,16.26V63.83A10.39,10.39,0,0,0,10.47,74.17H21.65L15.13,93,48.22,74.17H89.76A10.28,10.28,0,0,0,100,63.83V16.26A10.15,10.15,0,0,0,89.76,6Zm5.41,57.83a5.45,5.45,0,0,1-5.41,5.5H46.94l-23,13.1,4.53-13.1h-18a5.64,5.64,0,0,1-5.64-5.5V16.26a5.58,5.58,0,0,1,5.64-5.43H89.76a5.39,5.39,0,0,1,5.41,5.43Z" transform="translate(0 -6)"/><circle cx="49.92" cy="34.13" r="7.28"/><circle cx="74.19" cy="34.13" r="7.28"/><circle cx="25.65" cy="34.13" r="7.28"/></svg>',
  'sms-solid':
    '<svg class="cmm-sms-solid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 87"><defs><style>.cls-1{fill:none;}</style></defs><path d="M90,0H10.47A10.39,10.39,0,0,0,0,10.26V57.83A10.39,10.39,0,0,0,10.44,68.17H21.65L15.13,87,48.22,68.17H89.76A10.28,10.28,0,0,0,100,57.85V10.26A10.15,10.15,0,0,0,90,0ZM25.65,41.41a7.28,7.28,0,1,1,7.28-7.28A7.28,7.28,0,0,1,25.65,41.41Zm24.27,0a7.28,7.28,0,1,1,7.28-7.28A7.28,7.28,0,0,1,49.92,41.41Zm24.27,0a7.28,7.28,0,1,1,7.28-7.28A7.28,7.28,0,0,1,74.19,41.41Z" transform="translate(0 0)"/><circle class="cls-1" cx="49.92" cy="34.13" r="7.28" transform="translate(5.23 74.87) rotate(-76.72)"/><circle class="cls-1" cx="74.19" cy="34.13" r="7.28" transform="translate(-2.4 62.46) rotate(-45)"/><circle class="cls-1" cx="25.65" cy="34.13" r="7.28" transform="translate(-16.62 28.13) rotate(-45)"/><path d="M89.77,63.33" transform="translate(0 0)"/></svg>',
  'sms-bubble':
    '<svg xmlns="http://www.w3.org/2000/svg" class="cmm-sms-bubble" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM96 212.8c0-20.3 16.5-36.8 36.8-36.8H152c8.8 0 16 7.2 16 16s-7.2 16-16 16H132.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.3 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6C102.2 236.7 96 225.2 96 212.8zM372.8 176H392c8.8 0 16 7.2 16 16s-7.2 16-16 16H372.8c-2.7 0-4.8 2.2-4.8 4.8c0 1.6 .8 3.1 2.2 4l29.4 19.6c10.2 6.8 16.4 18.3 16.4 30.7c0 20.3-16.5 36.8-36.8 36.8H352c-8.8 0-16-7.2-16-16s7.2-16 16-16h27.2c2.7 0 4.8-2.2 4.8-4.8c0-1.6-.8-3.1-2.2-4l-29.4-19.6c-10.2-6.8-16.4-18.3-16.4-30.7c0-20.3 16.5-36.8 36.8-36.8zm-152 6.4L256 229.3l35.2-46.9c4.1-5.5 11.3-7.8 17.9-5.6s10.9 8.3 10.9 15.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240l-19.2 25.6c-3 4-7.8 6.4-12.8 6.4s-9.8-2.4-12.8-6.4L224 240v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-6.9 4.4-13 10.9-15.2s13.7 .1 17.9 5.6z"/></svg>',
  chat: '<svg xmlns="http://www.w3.org/2000/svg" class="cmm-chat" viewBox="0 0 640 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.3-11.4C134.1 343.3 169.8 352 208 352zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"/></svg>',
  'question-mark':
    '<svg class="cmm-question-mark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 740.92 1024"><path d="M484.92,992V800q0-14-9-23t-23-9h-192q-14,0-23,9t-9,23V992q0,14,9,23t23,9h192q14,0,23-9T484.92,992Z"/><path d="M740.92,320q0-88-55.5-163T546.92,41q-83-41-170-41-243,0-371,213-15,24,8,42l132,100q7,6,19,6,16,0,25-12,53-68,86-92,34-24,86-24,48,0,85.5,26t37.5,59q0,38-20,61t-68,45q-63,28-115.5,86.5T228.92,636v36q0,14,9,23t23,9h192q14,0,23-9t9-23q0-19,21.5-49.5a168.91,168.91,0,0,1,54.5-49.5q32-18,49-28.5t46-35q29-24.5,44.5-48t28-60.5Q740.92,364,740.92,320Z"/></svg>',
  calendar:
    '<svg class="cmm-calendar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M160 32V64H288V32C288 14.33 302.3 0 320 0C337.7 0 352 14.33 352 32V64H400C426.5 64 448 85.49 448 112V160H0V112C0 85.49 21.49 64 48 64H96V32C96 14.33 110.3 0 128 0C145.7 0 160 14.33 160 32zM0 192H448V464C448 490.5 426.5 512 400 512H48C21.49 512 0 490.5 0 464V192zM64 304C64 312.8 71.16 320 80 320H112C120.8 320 128 312.8 128 304V272C128 263.2 120.8 256 112 256H80C71.16 256 64 263.2 64 272V304zM192 304C192 312.8 199.2 320 208 320H240C248.8 320 256 312.8 256 304V272C256 263.2 248.8 256 240 256H208C199.2 256 192 263.2 192 272V304zM336 256C327.2 256 320 263.2 320 272V304C320 312.8 327.2 320 336 320H368C376.8 320 384 312.8 384 304V272C384 263.2 376.8 256 368 256H336zM64 432C64 440.8 71.16 448 80 448H112C120.8 448 128 440.8 128 432V400C128 391.2 120.8 384 112 384H80C71.16 384 64 391.2 64 400V432zM208 384C199.2 384 192 391.2 192 400V432C192 440.8 199.2 448 208 448H240C248.8 448 256 440.8 256 432V400C256 391.2 248.8 384 240 384H208zM320 432C320 440.8 327.2 448 336 448H368C376.8 448 384 440.8 384 432V400C384 391.2 376.8 384 368 384H336C327.2 384 320 391.2 320 400V432z"/></svg>',
  dollar:
    '<svg class="cmm-icon-dollar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M160 0C177.7 0 192 14.33 192 32V67.68C193.6 67.89 195.1 68.12 196.7 68.35C207.3 69.93 238.9 75.02 251.9 78.31C268.1 82.65 279.4 100.1 275 117.2C270.7 134.3 253.3 144.7 236.1 140.4C226.8 137.1 198.5 133.3 187.3 131.7C155.2 126.9 127.7 129.3 108.8 136.5C90.52 143.5 82.93 153.4 80.92 164.5C78.98 175.2 80.45 181.3 82.21 185.1C84.1 189.1 87.79 193.6 95.14 198.5C111.4 209.2 136.2 216.4 168.4 225.1L171.2 225.9C199.6 233.6 234.4 243.1 260.2 260.2C274.3 269.6 287.6 282.3 295.8 299.9C304.1 317.7 305.9 337.7 302.1 358.1C295.1 397 268.1 422.4 236.4 435.6C222.8 441.2 207.8 444.8 192 446.6V480C192 497.7 177.7 512 160 512C142.3 512 128 497.7 128 480V445.1C127.6 445.1 127.1 444.1 126.7 444.9L126.5 444.9C102.2 441.1 62.07 430.6 35 418.6C18.85 411.4 11.58 392.5 18.76 376.3C25.94 360.2 44.85 352.9 60.1 360.1C81.9 369.4 116.3 378.5 136.2 381.6C168.2 386.4 194.5 383.6 212.3 376.4C229.2 369.5 236.9 359.5 239.1 347.5C241 336.8 239.6 330.7 237.8 326.9C235.9 322.9 232.2 318.4 224.9 313.5C208.6 302.8 183.8 295.6 151.6 286.9L148.8 286.1C120.4 278.4 85.58 268.9 59.76 251.8C45.65 242.4 32.43 229.7 24.22 212.1C15.89 194.3 14.08 174.3 17.95 153C25.03 114.1 53.05 89.29 85.96 76.73C98.98 71.76 113.1 68.49 128 66.73V32C128 14.33 142.3 0 160 0V0z"/></svg>',
  search:
    '<svg class="cmm-icon-search" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M500.3 443.7l-119.7-119.7c27.22-40.41 40.65-90.9 33.46-144.7C401.8 87.79 326.8 13.32 235.2 1.723C99.01-15.51-15.51 99.01 1.724 235.2c11.6 91.64 86.08 166.7 177.6 178.9c53.8 7.189 104.3-6.236 144.7-33.46l119.7 119.7c15.62 15.62 40.95 15.62 56.57 0C515.9 484.7 515.9 459.3 500.3 443.7zM79.1 208c0-70.58 57.42-128 128-128s128 57.42 128 128c0 70.58-57.42 128-128 128S79.1 278.6 79.1 208z"/></svg>',
  ellipsis:
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"/></svg>',
  'fa-message-sms':
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM96 180.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L112 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0C112.5 144 96 160.5 96 180.8zM372.8 144c-20.3 0-36.8 16.5-36.8 36.8c0 12.3 6.2 23.8 16.4 30.7l29.4 19.6c1.3 .9 2.2 2.4 2.2 4c0 2.7-2.2 4.8-4.8 4.8L352 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l27.2 0c20.3 0 36.8-16.5 36.8-36.8c0-12.3-6.2-23.8-16.4-30.7l-29.4-19.6c-1.3-.9-2.2-2.4-2.2-4c0-2.7 2.2-4.8 4.8-4.8l19.2 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-19.2 0zm-152 6.4c-4.1-5.5-11.3-7.8-17.9-5.6S192 153.1 192 160l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-6.9-4.4-13-10.9-15.2s-13.7 .1-17.9 5.6L256 197.3l-35.2-46.9z"/></svg>',
  'fa-message-dots':
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-80-96 0c-35.3 0-64-28.7-64-64L0 64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>',
};
type CmmIcon = keyof typeof CMM_ICON;

type ReplaceHyphenWithUnderscore<S extends string> =
  S extends `${infer P1}-${infer P2}`
    ? `${ReplaceHyphenWithUnderscore<P1>}_${ReplaceHyphenWithUnderscore<P2>}`
    : S;

const CMMGraphic: {
  [K in CmmIcon as ReplaceHyphenWithUnderscore<Uppercase<K>>]: K;
} = {
  PHONE: 'phone',
  MAP_PIN: 'map-pin',
  EMAIL: 'email',
  HOUSE: 'house',
  SMS: 'sms',
  SMS_SOLID: 'sms-solid',
  SMS_BUBBLE: 'sms-bubble',
  CHAT: 'chat',
  QUESTION_MARK: 'question-mark',
  CALENDAR: 'calendar',
  DOLLAR: 'dollar',
  SEARCH: 'search',
  ELLIPSIS: 'ellipsis',
  FA_MESSAGE_SMS: 'fa-message-sms',
  FA_MESSAGE_DOTS: 'fa-message-dots',
} as const;

class CMMButtonAction {
  private static whichChat: 'be' | 'podium' | null = null;

  static OPEN_SANITY_LOCATIONS() {}

  /** Open chat depending on what chat is loaded */
  static OPEN_CHAT() {
    if (CMMButtonAction.whichChat === null) {
      if (document.querySelector('[id^="bf-revz-widget"]')) {
        CMMButtonAction.whichChat = 'be';
      } else if (document.querySelector('.podium-website-widget')) {
        CMMButtonAction.whichChat = 'podium';
      }
    }

    switch (CMMButtonAction.whichChat) {
      case 'be':
        if (!(window as any).be_webchat?.windowOpened) {
          window.postMessage('icon-clicked***floating', '*');
        } else {
          window.postMessage('icon-closed***floating', '*');
        }
        break;
      case 'podium':
        (window as any).PodiumWebChat?.open();
        break;
    }
  }

  /** Opens ConvertBoost modal */
  static OPEN_CONVERTBOOST_MODAL() {
    const modalElem = document.querySelector('#cmm-call-to-action-modal');

    if (modalElem.classList.contains('cmm-modal-open')) {
      (modalElem as any).hideModal();
    } else {
      (modalElem as any).showModal();
    }
  }
}

type CmmFont = {
  /** Set the font family. 'AUTO' tries to automatically grab the font
   * depending on the CMS, but may not always work. */
  family?: 'AUTO' | (string & {});
};
type ModalButtonHTMLOptions = {
  link?: string;
  action?: (ev: MouseEvent) => void;
  /** Links directly to the location banner
   *
   * **NOTE: Hunter Douglas sites only**
   * @default false */
  location_link?: boolean;
  title?: string;
  description?: string;
  description_position?: 'above' | 'below';
  aria_label?: string;
  txt_color?: string;
  txt_color_hover?: string;
  bg_color?: string;
  bg_color_hover?: string;
  text_shadow?: boolean | string;
  text_shadow_hover?: boolean | string;
  border?: string;
  border_hover?: string;
  atts?: { [key: string]: string };
  /** @deprecated use `classname` property */
  class_list?: string[];
  classname?: string[];
  link_target?: string;
  /** Convert the text to the phone number (if tel link) on click for desktop/tablet
   * @default true */
  text_to_number?: boolean;
  /** Show the button title if the button is a tel link, rather than the phone number
   * @default false */
  show_number_title?: boolean;
  icon?: CmmIcon | (string & {});
};

/**
 * Automatically generates button HTML
 */
function cmmGenerateButtonHTML(
  options: ModalButtonHTMLOptions,
  customLink: string | null,
  isModalButton: boolean,
  wrapperTarget: string,
  buttonCount: number,
) {
  //set default values
  options = Object.assign<ModalButtonHTMLOptions, ModalButtonHTMLOptions>(
    {
      link: '#',
      location_link: false,
      title: '',
      description: '',
      classname: [],
      text_to_number: true,
      show_number_title: false,
    },
    options,
  );

  if (options.class_list) {
    options.classname.push(...options.class_list);
  }

  let normalStyle = '';
  if (options.txt_color) {
    normalStyle += 'color: ' + options.txt_color + ';';
  }
  if (options.bg_color) {
    normalStyle += `background: ${options.bg_color};`;

    if (options.border) {
      normalStyle += `border: ${options.border}`;
    } else {
      normalStyle += `border-color: ${options.bg_color};`;
    }
  }
  if (options.text_shadow) {
    if (typeof options.text_shadow === 'boolean') {
      options.classname.push('cmm-text-shadow');
    } else {
      normalStyle += `text-shadow: ${options.text_shadow};`;
    }
  }

  let hoverStyle = '';
  if (options.txt_color_hover) {
    hoverStyle += 'color: ' + options.txt_color_hover + ';';
  }
  if (options.bg_color_hover) {
    hoverStyle += `background: ${options.bg_color_hover};`;

    if (options.border_hover) {
      hoverStyle += `border: ${options.border_hover}`;
    } else {
      hoverStyle += `border-color: ${options.bg_color_hover};`;
    }
  }
  if (options.text_shadow_hover) {
    if (typeof options.text_shadow_hover === 'boolean') {
      options.classname.push('cmm-text-shadow-hover');
    } else {
      hoverStyle += `text-shadow: ${options.text_shadow_hover};`;
    }
  }

  let allAtts = '';
  for (let att in options.atts) {
    allAtts += ' ' + att + '="' + options.atts[att] + '"';
  }

  let btnHTML = '';

  let buttonNumClass = `cmm-${isModalButton ? 'modal-' : ''}button-${buttonCount}`;
  options.classname.push(buttonNumClass);
  if (normalStyle) {
    btnHTML += `<style>${wrapperTarget} .${buttonNumClass}{ ${normalStyle} }</style>`;
  }
  if (hoverStyle) {
    btnHTML += `<style>${wrapperTarget} .${buttonNumClass}:hover{ ${hoverStyle} }</style>`;
  }

  if (options.location_link && customLink) {
    options.link = customLink;
  } else if (options.link.startsWith('tel:')) {
    if (options.text_to_number && options.show_number_title) {
      options.classname.push('cmm-convert-text-to-num');
    } else if (options.show_number_title) {
      let numbers = CMMHelper.formatPhoneNumber(options.link);
      options.title = numbers.text;
    }
  } else if (options.link.startsWith('sms:')) {
    // Shopify Fix
    // Overrides the link target otherwise AJAX loading pages will go blank
    if (
      (window as any).cmmGetGenerator &&
      (window as any).cmmGetGenerator() ===
        (window as any).CMM_GENERATOR_SHOPIFY
    ) {
      options.link_target = '_blank';
    }
  }

  let target = '';
  if (options.link_target) {
    target = ` target="${options.link_target}"`;
  }

  let ariaLabel = '';
  if (options.aria_label) {
    ariaLabel = ` aria-label="${options.aria_label}"`;
  }

  let iconHTML = '';
  if (options.icon) {
    options.classname.push('with-icon');

    iconHTML += '<span class="button-icon">';
    if (options.icon in CMM_ICON) {
      iconHTML += CMM_ICON[options.icon];
    } else {
      iconHTML += options.icon;
    }
    iconHTML += '</span>';
  }

  // FIXME: Update this to use addEventListener in the future
  if (options.link && options.link !== '#') {
    btnHTML += `<a href="${options.link}"`;
  } else if (options.action === CMMButtonAction.OPEN_SANITY_LOCATIONS) {
    btnHTML += `<button onclick="CMMButtonAction.OPEN_SANITY_LOCATIONS(); CMMButtonAction.OPEN_CONVERTBOOST_MODAL()"`;
  } else if (options.action === CMMButtonAction.OPEN_CONVERTBOOST_MODAL) {
    btnHTML += `<button onclick="CMMButtonAction.OPEN_CONVERTBOOST_MODAL()"`;
  } else if (options.action === CMMButtonAction.OPEN_CHAT) {
    btnHTML += `<button onclick="CMMButtonAction.OPEN_CHAT()"`;
  }

  btnHTML += `
    class="${['cmm-button'].concat(options.classname).join(' ')}"
    ${target}
    ${ariaLabel}
    ${allAtts}
  >`;

  btnHTML += iconHTML;
  btnHTML += `<span class="button-title">${options.title}</span>`;

  if (options.description) {
    let inlineStyles = [];
    if (options.description_position === 'above') {
      inlineStyles.push('order: -1;');
    } else if (options.description_position === 'below') {
      inlineStyles.push('order: 0;');
    }

    const stylesAttribute = inlineStyles.length
      ? `style="${inlineStyles.join('')}"`
      : '';

    btnHTML += `<span class="button-desc" ${stylesAttribute}>${options.description}</span>`;
  }

  if (options.link && options.link !== '#') {
    btnHTML += '</a>';
  } else if (options.action) {
    btnHTML += '</button>';
  }

  return btnHTML;
}

type ModalOptions = {
  /** @deprecated use `classname` property */
  class_list?: (
    | 'cmm-modal-sidebar'
    | 'cmm-modal-sidebar-right'
    | (string & {})
  )[];
  classname?: (
    | 'cmm-modal-sidebar'
    | 'cmm-modal-sidebar-right'
    | (string & {})
  )[];
  /** @default 'modal' */
  display_style?: 'modal' | 'tooltip';
  /** Used for tooltip display style
   * @default true */
  show_pointer?: boolean;
  /** @default true */
  show_blocker?: boolean;
  /** @default true */
  blocker_closes?: boolean;
  /** @default 'Contact Us' */
  header_text?: string;
  header_color?: string;
  header_text_color?: string;
  logo_url?: string;
  description_text?: string;
  description_text_color?: string;
  /** @default 'Contact us using one of the above options.' */
  footer_text?: string;
  footer_color?: string;
  footer_text_color?: string;
  buttons: ModalButtonHTMLOptions[];
  show_overlay?: boolean;
  /** Sets the font (only family at the moment)
   * @default the `<body>` element font */
  font?: CmmFont;
  //tawk_to?: ModalTawkToOptions; //TODO: Does this need to be here?
  //TODO: add tooltip display_style offset that matches with current CTA offset
};
/**
 * Setup the modal listeners
 */
function CmmModal(options: ModalOptions) {
  this.modalOptions = null;
  this.modal = null;
  this.blocker = null;
  this.buttonCount = 0;
  this.visible = false;
  this.ctaTooltip = document.querySelector<HTMLElement>(
    '.cmm-call-to-action .cmm-cta-box',
  );

  this.afterSetup = null;

  this.construct = (options: ModalOptions): Promise<void> => {
    //set default values
    this.modalOptions = Object.assign<ModalOptions, ModalOptions>(
      {
        classname: [],
        display_style: 'modal',
        show_pointer: true,
        show_blocker: true,
        blocker_closes: true,
        header_text: 'Contact Us',
        footer_text: 'Contact us using one of the above options.',
        buttons: [],
      },
      options,
    );

    if (this.modalOptions.class_list) {
      this.modalOptions.classname.push(...this.modalOptions.class_list);
    }

    return this.setupHTML(this.modalOptions).then((_) => {
      this.setupListeners();
    });
  };

  this.setupHTML = (options: ModalOptions): Promise<boolean> => {
    if (options.display_style == 'tooltip') {
      options.classname.push('cmm-modal-tooltip');

      if (options.show_pointer) {
        options.classname.push('cmm-modal-pointer');
      }
    }

    let fontStyle = '';
    if (options.font) {
      if (options.font.family) {
        let family = '';
        if (options.font.family === 'AUTO') {
          if (cmmGetGenerator() === CMM_GENERATOR_INTERNAL) {
            family = window.getComputedStyle(
              document.querySelector('#dmStyle_innerContainer'),
            ).fontFamily;
          }
        } else {
          family = options.font.family;
        }
        fontStyle += `font-family: ${family.replaceAll(`"`, `'`)};`;
      }
    }

    let cssProperties = [];
    if (options.header_color) {
      cssProperties.push(`--headerColor: ${options.header_color};`);
    }

    let modalStyle = `style="${fontStyle} ${cssProperties.join(' ')}"`;
    let modalClass = `class="${['cmm-modal'].concat(options.classname).join(' ')}"`;
    let modalHTML = `<div id="cmm-call-to-action-modal" aria-label="Contact Us Modal" aria-modal="true" aria-hidden="true" role="dialog" ${modalClass} ${modalStyle}>`;

    if (options.show_overlay) {
      modalHTML += '<div class="cmm-background-overlay"></div>';
    }

    // constrain tab navigation
    // modalHTML += '<div tabindex="0" class="cmm-tabindex"></div>';
    // ensure that header image alt text exists
    const headerImageSrcIndex = options.header_text.indexOf('src=');
    if (headerImageSrcIndex > -1 && !options.header_text.includes(' alt=')) {
      options.header_text =
        options.header_text.slice(0, headerImageSrcIndex) +
        'alt="business logo" ' +
        options.header_text.slice(headerImageSrcIndex);
    }

    let headerStyle = '';
    if (options.header_color) {
      headerStyle += `background-color: ${options.header_color};`;
    }
    if (options.header_text_color) {
      headerStyle += `color: ${options.header_text_color};`;
    }
    modalHTML += `<div class="cmm-modal-header" style="${headerStyle}">${options.header_text}</div>`;

    if (options.logo_url) {
      modalHTML += `<div class="cmm-modal-logo"><img src="${options.logo_url}"></div>`;
    }

    modalHTML += '<div class="cmm-modal-content">';

    let descriptionStyle = '';
    if (options.description_text_color) {
      descriptionStyle += `color: ${options.description_text_color};`;
    }
    if (options.description_text) {
      modalHTML += `<p style="${descriptionStyle}">${options.description_text}</p>`;
    }

    // HD location banner (not copied)
    const button_location_link = '';

    //buttons
    modalHTML +=
      options.buttons
        ?.map((buttonOptions) => {
          this.buttonCount++;
          return cmmGenerateButtonHTML(
            buttonOptions,
            button_location_link,
            true,
            '#cmm-call-to-action-modal',
            this.buttonCount,
          );
        })
        .join('') ?? '';

    let footerStyle = '';
    if (options.footer_color) {
      footerStyle += `background-color: ${options.footer_color};`;
    }
    if (options.footer_text_color) {
      footerStyle += `color: ${options.footer_text_color};`;
    }
    modalHTML += `</div><div class="modal-footer cmm-modal-footer" style="${footerStyle}">${options.footer_text}</div>`;

    // close button
    modalHTML +=
      '<button class="close" type="button" aria-label="Close Modal"></button>';

    // constrain tab navigation
    // modalHTML += '<div tabindex="0" class="cmm-tabindex"></div>';

    // close the modal wrapper
    modalHTML += `</div>`;

    //insert modal then blocker
    return cmmInsertHtml(modalHTML)
      .then((modal) => {
        this.modal = modal[0];

        // attach open and close to the modal element itself
        this.modal.showModal = () => {
          this.showModal();
        };
        this.modal.hideModal = () => {
          this.hideModal();
        };

        // close on Esc
        document.addEventListener('keydown', (e: KeyboardEvent) => {
          if (e.key == 'Escape') {
            this.hideModal();
          }
        });

        if (options.show_blocker) {
          let blockerHTML = '<div id="cmm-modal-blocker"></div>';
          return cmmInsertHtml(blockerHTML);
        } else {
          return null;
        }
      })
      .then((blocker) => {
        this.blocker = blocker ? blocker[0] : null;

        return true;
      });
  };

  this.setupListeners = () => {
    document
      .querySelectorAll(
        '.cmm-call-to-action a[href^="javascript:"], .cmm-call-to-action-link',
      )
      .forEach((elem) => {
        elem.addEventListener('click', (e) => {
          e.preventDefault();

          //close if modal is shown, otherwise open
          if (this.visible) {
            this.hideModal();
          } else {
            this.showModal();
          }
        });
      });

    //changes listeners if blocker closes the modal or not
    let blocker_close_selector = '';
    if (this.modalOptions.blocker_closes) {
      blocker_close_selector = ', #cmm-modal-blocker';
    }

    document
      .querySelectorAll(
        '#cmm-call-to-action-modal .close' + blocker_close_selector,
      )
      .forEach((elem) => {
        elem.addEventListener('click', (e) => {
          this.hideModal();
        });
      });

    cmmSetupEventTracking([
      {
        selector: '#cmm-call-to-action-modal a',
        action: (elem) => {
          const foundTitle = elem.querySelector('.button-title')?.textContent;
          if (foundTitle) {
            return `ConvertBoost© Button - ${foundTitle}`;
          } else {
            return 'ConvertBoost© Button';
          }
        },
        ga4Event: 'cmm_convertboost',
      },
      {
        selector: '#cmm-call-to-action-modal .close' + blocker_close_selector,
        action: 'ConvertBoost© Modal Closed',
        ga4Event: 'cmm_convertboost',
      },
    ]);

    //Tooltip modal events
    /*
    jQuery("#cmm-call-to-action-modal.cmm-modal-tooltip:not(.cmm-modal-blocker)").on('modal:block', function() {
      jQuery("body").css("overflow", "");
      jQuery(".blocker").css({"background": "transparent", "pointer-events": "none"});
      jQuery(this).css("pointer-events", "all");
    });
    */

    //Sidebar modal events
    /*
    jQuery("#cmm-call-to-action-modal.cmm-modal-tooltip:not(.cmm-modal-blocker)").on('modal:block', function() {
      jQuery("body").css("overflow", "");
      jQuery(".blocker").css({"background": "transparent", "pointer-events": "none"});
      jQuery(this).css("pointer-events", "all");
    });
    jQuery("#cmm-call-to-action-modal.cmm-modal-sidebar-right").on('modal:block', function() {
      jQuery(".blocker").css("z-index", "1001");
    });

    jQuery("#cmm-call-to-action-modal.cmm-modal-sidebar").on('modal:open', function() {
      jQuery(this).addClass("cmm-modal-sidebar-open");
    });
    jQuery("#cmm-call-to-action-modal.cmm-modal-sidebar").on('modal:before-close', function() {
      jQuery(this).removeClass("cmm-modal-sidebar-open");
    });
    */

    var mobileSize = 1024; /*set to pixel-width of mobile/tablet viewport*/
    document
      .querySelectorAll<HTMLAnchorElement>(
        '#cmm-call-to-action-modal a.cmm-convert-text-to-num[href^="tel:"]',
      )
      .forEach((elem) => {
        let phoneNumber = elem.getAttribute('href');

        let numbers = CMMHelper.formatPhoneNumber(phoneNumber);

        var oText = elem.querySelector('.button-title').textContent;

        elem.setAttribute('data-phone-num', numbers.link);
        elem.setAttribute('data-num-text', numbers.text);
        elem.setAttribute('data-o-text', oText);
        elem.addEventListener('click', (e) => {
          if (window.innerWidth > mobileSize) {
            e.preventDefault();
            if (!elem.classList.contains('cmm-text-to-num')) {
              cmmTextToNum(elem);
            } else {
              cmmTextFromNum(elem);
            }
          }
        });
      });
    document.addEventListener('click', (e) => {
      document
        .querySelectorAll<HTMLAnchorElement>(
          '#cmm-call-to-action-modal .cmm-text-to-num',
        )
        .forEach((elem) => {
          var clickedButton = (e.target as HTMLElement).closest('.cmm-button');
          if (elem !== clickedButton) {
            cmmTextFromNum(elem);
          }
        });
    });

    /** HOUSECALLPRO OVERLAP FIX START */
    type listeningOrigins = 'https://messages.housecallpro.com';
    window.addEventListener('message', (message) => {
      const origin: listeningOrigins = message.origin as any;

      switch (origin) {
        case 'https://messages.housecallpro.com':
          let jsonData: { type: string; open?: boolean } = null;
          try {
            jsonData = JSON.parse(message.data);
          } catch (e) {}

          if (!jsonData) return; // malformed message

          if (jsonData.type !== 'toggleChat') {
            return;
          }

          if (jsonData.open) {
            document
              .querySelectorAll<HTMLElement>('.cmm-call-to-action')
              .forEach((cta) => {
                cta.style.zIndex = '1';
              });
          } else if (jsonData.open === false) {
            document
              .querySelectorAll<HTMLElement>('.cmm-call-to-action')
              .forEach((cta) => {
                cta.style.zIndex = '';
              });
          }
          break;
        default:
          return;
      }
    });
    /** HOUSECALLPRO OVERLAP FIX END */
  };

  this.showModal = () => {
    this.visible = true;
    this.modal.classList.add('cmm-modal-open');
    this.ctaTooltip?.classList.add('cmm-modal-open');
    if (this.blocker) document.body.style.overflow = 'hidden';

    // set accessibility
    this.modal.querySelector('a, button')?.focus();
    this.modal.setAttribute('aria-hidden', false);
  };

  this.hideModal = () => {
    this.modal.classList.remove('cmm-modal-open');
    this.ctaTooltip?.classList.remove('cmm-modal-open');
    if (this.blocker) document.body.style.overflow = '';
    this.visible = false;

    // set aria hidden
    // set accessibility
    this.modal.setAttribute('aria-hidden', true);
  };

  this.afterSetup = this.construct(options);
}

/**
 *
 */
function cmmSetupModal(options: ModalOptions): any {
  let cmmModal = new CmmModal(options);
  return cmmModal.afterSetup;

  /*
  //old implementation
  loadStyleCMM("https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.css");
  loadScriptCMM("https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.js", null, {async: true, defer: false}, function() {
    
  });
  */
}

type Concat<T extends string[]> = T extends [infer F, ...infer R]
  ? F extends string
    ? R extends string[]
      ? `${F}${Concat<R>}`
      : never
    : never
  : '';
type FloatingCTAAnimation = 'icon-shake' | 'button-ripple';
type FloatCTATooltipOptions = {
  /** set a custom message for the tooltip */
  text?: string;
  /** @deprecated use `classname` property */
  class_list?: string[];
  /** ways to style the tooltip */
  classname?: string[];
  /** devices to show the tooltip on */
  devices?: DeviceArray;
  /** @default true */
  show_pointer?: boolean;
  /** @default 'top' */
  position?: 'left' | 'top';
};
type FloatingCTAOptions = {
  /** @default 'cta' */
  mode?: 'cta' | 'modal';
  /** Text will be shown after the icon (if an icon is used) */
  text?: string;
  /** Required if not using the 'modal' mode*/
  link?: string;
  /** Link target */
  target?: string;
  /** @deprecated use `classname` property */
  class_list?: string[];
  /** extra classes to apply to the CTA floating widget (like 'cmm-button-style') */
  classname?: string[];
  /** Set the CTA icon. A custom SVG HTML string can be used too.
   * @default 'phone' */
  icon?: CmmIcon | 'none' | (string & {});
  /** Set the CTA icon size when displaying the icon-only mode (i.e. no text)
   * @default 'large' */
  icon_size?:
    | 'small'
    | 'medium'
    | 'large'
    | 'wti'
    | 'podium'
    | 'podium-wide'
    | 'tawkto'
    | 'chekkit'
    | 'facebook'
    | 'swell'
    | 'intercom'
    | 'housecallpro';
  // | 'leadconnectorhq';
  icon_color?: string;
  /** Set to hide the icon shadow
   * @default false */
  hide_icon_shadow?: boolean;
  /** Set to automatically switch to the icon on mobile viewports
   * @default true */
  icon_on_mobile?: boolean;
  /** Set the CSS property for the text shadow */
  text_shadow?: string;
  tooltip?: FloatCTATooltipOptions;
  /** Sets the font (only family at the moment)
   * @default the `<body>` element font */
  font?: CmmFont;
  /** devices to show the CTA on */
  devices?: DeviceArray;
  /** where to position on the screen
   * @default `'bottom-right'` */
  position?: 'bottom-left' | 'bottom-right';
  /** offset from current position */
  offset?: {
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  /** icon color */
  color?: string;
  /** border styles
   * @example `1px solid #333` */
  border?: string;
  /** border radius */
  border_radius?: number;
  /** list of animations to apply */
  animations?: (
    | FloatingCTAAnimation
    | Concat<[FloatingCTAAnimation, '__hover']>
  )[];
  extra_attributes?: Record<string, string>;
  disable_propagation?: boolean;
};

/**
 *
 */
function cmmSetupFloatingCTA(
  optionsArray: FloatingCTAOptions[],
): Promise<HTMLElement[]> {
  let ctaHTML = '';
  document.querySelectorAll('a');

  for (let index = 0; index < optionsArray.length; index++) {
    let options = optionsArray[index];

    // set defaults
    Object.assign(
      options,
      Object.assign<FloatingCTAOptions, FloatingCTAOptions>(
        {
          mode: 'cta',
          classname: [],
          text: '',
          icon: 'phone',
          icon_on_mobile: true,
          devices: [],
          position: 'bottom-right',
          hide_icon_shadow: false,
        },
        options,
      ),
    );

    if (options.class_list) {
      options.classname.push(...options.class_list);
    }

    //sets up mobile-only CTA button
    if (
      options.icon_on_mobile &&
      (!options.devices?.length || options.devices.includes('mobile'))
    ) {
      if (!options.devices?.length) {
        options.devices = ['desktop', 'laptop', 'tablet'];
      }
      options.devices = options.devices.filter((device) => device !== 'mobile');
      let mobileOptions = { ...options };
      mobileOptions.icon_on_mobile = false;
      if (mobileOptions.icon === 'none') {
        delete mobileOptions.icon;
      }
      delete mobileOptions.text;
      mobileOptions.devices = ['mobile'];

      optionsArray.push(mobileOptions);
    }

    options.classname.push(`cmm-call-to-action-${index + 1}`);

    if (options.mode === 'modal' && !options.link) {
      options.link = 'javascript:void(0)';
    } else {
      // cta - call to action
      if (!options.link) {
        options.link = '#';
        //'tel:+1' + options.phone_number.replace(/[()\s-]/g, '');
      }
    }

    if (options.devices?.length) {
      options.classname = options.classname.concat(
        cmmShowDeviceClassList(options.devices),
      );
    }

    let tooltipHTML = '';
    if (options.tooltip) {
      options.tooltip = Object.assign<
        FloatCTATooltipOptions,
        FloatCTATooltipOptions
      >(
        {
          text: 'How may we help you today?',
          classname: [],
          show_pointer: true,
          position: 'top',
        },
        options.tooltip,
      );

      if (options.tooltip.class_list) {
        options.tooltip.classname.push(...options.tooltip.class_list);
      }

      if (options.tooltip.devices) {
        options.tooltip.classname = options.tooltip.classname.concat(
          cmmShowDeviceClassList(options.tooltip.devices),
        );
      }

      if (options.tooltip.position === 'left') {
        options.tooltip.classname.push('cmm-cta-left');
      }

      if (options.tooltip.show_pointer) {
        options.tooltip.classname.push('cmm-cta-pointer');
      }

      let target = '';
      if (options.target) {
        target = ' target="' + options.target + '"';
      }

      tooltipHTML =
        '<div class="' +
        ['cmm-cta-box'].concat(options.tooltip.classname).join(' ') +
        '"><a href="' +
        options.link +
        '"' +
        target +
        '>' +
        options.tooltip.text +
        '</a></div>';
    }

    let styles = '<style>';
    if (options.text_shadow) {
      styles += `.cmm-call-to-action-${index + 1} { text-shadow: ${options.text_shadow}; }`;
    }
    if (options.color) {
      styles += `div.cmm-call-to-action-${index + 1} > a {--_cmm-cta-bg-color: ${options.color};}`;
    }
    if (options.border) {
      styles += `div.cmm-call-to-action-${index + 1} > a {border: ${options.border};}`;
    }
    if (options.border_radius !== undefined) {
      styles += `div.cmm-call-to-action-${index + 1} > a {--_cmm-cta-border-radius: ${
        options.border_radius
      }px;}`;
    }
    if (options.position) {
      options.classname.push(`cmm-cta-position-${options.position}`);
    }
    if (options.offset) {
      let margins = '';

      if (options.offset.top) margins += `margin-top: ${options.offset.top}px;`;
      if (options.offset.right)
        margins += `margin-right: ${options.offset.right}px;`;
      if (options.offset.bottom)
        margins += `margin-bottom: ${options.offset.bottom}px;`;
      if (options.offset.left)
        margins += `margin-left: ${options.offset.left}px;`;

      if (margins) {
        styles += `.cmm-call-to-action-${index + 1} { ${margins} }`;
      }
    }
    if (options.icon_color) {
      styles += `div.cmm-call-to-action-${index + 1} > a svg {fill: ${options.icon_color}; color: ${
        options.icon_color
      };}`;
    }
    if (options.hide_icon_shadow) {
      styles += `div.cmm-call-to-action-${index + 1} > a svg {filter: none; -webkit-filter: none;}`;
    }
    let fontStyle = '';
    if (options.font) {
      if (options.font.family) {
        let family = '';
        if (options.font.family === 'AUTO') {
          if (cmmGetGenerator() === CMM_GENERATOR_INTERNAL) {
            family = window.getComputedStyle(
              document.querySelector('#dmStyle_innerContainer'),
            ).fontFamily;
          }
        } else {
          family = options.font.family;
        }
        fontStyle += `font-family: ${family.replaceAll(`"`, `'`)};`;
      }
      styles += `div.cmm-call-to-action-${index + 1} { ${fontStyle} }`;
    }
    styles += '</style>';

    let linkLabel = 'Contact us';
    let ariaPopup = '';
    if (options.mode === 'modal') {
      linkLabel = 'Open contact modal';
      ariaPopup = 'aria-haspopup="dialog"';
    } else if (options.text) {
      if (options.link.startsWith('tel:')) {
        linkLabel = 'Call Us';
      } else {
        linkLabel = options.text;
      }
    }

    let linkHTML = '';
    linkHTML += `<a href="${options.link}" aria-label="${linkLabel}" ${ariaPopup}>`;

    if (options.icon !== 'none') {
      if (options.icon in CMM_ICON) {
        linkHTML += CMM_ICON[options.icon];
      } else {
        linkHTML += options.icon;
      }
    }

    if (options.icon_size && !options.text) {
      options.classname.push(`cmm-cta-icon-${options.icon_size}`);
    }

    if (options.text) {
      linkHTML += options.text;
      options.classname.push('cmm-cta-with-text');
    }

    if (options.animations) {
      options.classname.push(
        options.animations.map((a) => `cmm-cta-animation-${a}`).join(' '),
      );
    }

    linkHTML += '</a>';

    /*
    if (options.cta_button) {
      options.cta_classes.push('cmm-button-style');

      if (options.cta_button_text) {
        linkHTML += '<style>.cmm-call-to-action.cmm-button-style > a:after{content:"' + options.cta_button_text + '";}</style>';
      }
    }
    */

    const ctaAttributes = Object.keys(options.extra_attributes ?? {})
      .map((key) => `${key}="${options.extra_attributes[key]}"`)
      .join(' ');

    ctaHTML += `<div
        class="${['cmm-call-to-action'].concat(options.classname).join(' ')}"
        data-event-id="${index + 1}"
        ${ctaAttributes}
      >
        ${styles}
        ${tooltipHTML}${linkHTML}
      </div>`;
  }

  return cmmInsertHtml(ctaHTML);
}

type CTAOptions = {
  cta_options?: FloatingCTAOptions[];
  modal_options?: ModalOptions;
};

/**
 * Sets up the CTA button and modal
 * @deprecated old function name - use `cmmSetupConvertBoost`
 */
var cmmSetupCTAOptions = cmmSetupConvertBoost;
/**
 * Loads the CTA button and modal
 */
function cmmSetupConvertBoost(options: CTAOptions): Promise<void> {
  let setupPromise = new Promise<void>((resolve, reject) => {
    let floatingCTAPromise = Promise.resolve();
    if (options.cta_options) {
      floatingCTAPromise = cmmSetupFloatingCTA(options.cta_options).then(
        (cta_buttons) => {
          cta_buttons.forEach((button) => {
            let buttonEventID = button.getAttribute('data-event-id');
            let tagSelector = `.cmm-call-to-action[data-event-id="${buttonEventID}"] > a`;

            if (button.querySelector('a').href.startsWith('javascript:')) {
              cmmSetupEventTracking([
                {
                  selector: tagSelector,
                  action: (elem) => {
                    //action text indicates if the modal will close or open
                    let action = 'ConvertBoost© ';
                    if (
                      document
                        .querySelector('#cmm-call-to-action-modal')
                        .classList.contains('cmm-modal-open')
                    ) {
                      action += 'Closed';
                    } else {
                      action += 'Opened';
                    }
                    return action;
                  },
                  ga4Event: 'cmm_convertboost',
                },
              ]);
            } else {
              cmmSetupEventTracking([
                {
                  selector: tagSelector,
                  action: 'Floating Call to Action',
                },
              ]);
            }
          });
        },
      );
    }
    if (options.modal_options) {
      floatingCTAPromise
        .then((_) => cmmSetupModal(options.modal_options))
        .then((_) => resolve());
    } else {
      floatingCTAPromise.then((_) => resolve());
    }
  });

  return setupPromise
    .then((data) => {
      //watch for podium bubble size change
      function modifyPodiumClasses(podiumBubbleElem: HTMLIFrameElement) {
        // uses wide style
        if (podiumBubbleElem.clientWidth > 150) {
          document
            .querySelectorAll('.cmm-cta-icon-podium')
            .forEach((e) => e.classList.add('cmm-cta-icon-podium-wide'));
        }
        // uses left-aligned button
        if (isNaN(parseInt(podiumBubbleElem.style.right))) {
          document
            .querySelectorAll('.cmm-cta-icon-podium')
            .forEach((e) => e.classList.add('cmm-cta-icon-podium-left'));
        }
      }
      function watchForPodiumChanges(podiumBubbleElem: HTMLIFrameElement) {
        modifyPodiumClasses(podiumBubbleElem);
        const podiumConfig = { attributes: true };
        const podiumObserver = new MutationObserver(
          (mutationList, observer) => {
            modifyPodiumClasses(podiumBubbleElem);
          },
        );
        podiumObserver.observe(podiumBubbleElem, podiumConfig);
      }
      const podiumBubble =
        document.querySelector<HTMLIFrameElement>('#podium-bubble');
      if (podiumBubble) {
        watchForPodiumChanges(podiumBubble);
      } else {
        const targetNode = document.body;
        const config = { attributes: false, childList: true, subtree: true };
        const observer = new MutationObserver((mutationList, observer) => {
          mutationList.forEach((mutation) => {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if ((node as HTMLElement).id === 'podium-bubble') {
                  watchForPodiumChanges(node as HTMLIFrameElement);
                  observer.disconnect();
                }
              });
            }
          });
        });
        observer.observe(targetNode, config);
      }

      return data;
    })
    .then((data) => {
      // track Userway
      const uwExists =
        document.querySelector('.cmm-call-to-action.cmm-userway-target') !==
        null;
      if (!uwExists) {
        return data;
      }

      cmmSetupEventTracking([
        {
          selector: '.cmm-call-to-action.cmm-userway-target',
          action: 'Userway FAB',
          label: window.location.href,
          ga4Event: 'click',
        },
      ]);

      return data;
    });
}

class CMMHelper {
  static readonly PHONE_NUMBER_FORMATS = {
    PARENTHESES: 'parentheses',
    HYPHENS: 'hyphens',
    PERIODS: 'periods',
  } as const;

  /**
   * This will format to output a link (minus tel:) and a formatted number.
   *
   * ## NOTES:
   * - Phone numbers can have multiple commas to add a 2 second pause per comma
   * before auto-entering the next number into the dialer.
   * - This system only adds a single comma. I
   * - Semi-colons add a popup requesting if the extension should be called.
   */
  static formatPhoneNumber(
    phoneNumber: string,
    format: (typeof CMMHelper.PHONE_NUMBER_FORMATS)[keyof typeof CMMHelper.PHONE_NUMBER_FORMATS] = CMMHelper
      .PHONE_NUMBER_FORMATS.PARENTHESES,
  ): {
    /** Does _**NOT**_ contain the tel:/sms: protocol */
    link: string;
    /** Formatted phone number based on `format` parameter */
    text: string;
  } {
    let [phoneNumberMain, phoneNumberExtension] = phoneNumber
      .replaceAll(/[^0-9;,]/g, '')
      .split(/[;,]/)
      .filter((t) => !!t);

    // error if too long or too short
    if (phoneNumberMain.length > 11 || phoneNumberMain.length < 10) {
      throw new Error('Phone number not a valid format.');
    }

    // exclude the US country code
    if (phoneNumberMain.length === 11) {
      if (phoneNumberMain.charAt(0) !== '1') {
        throw new Error('Phone number not a valid format.');
      }

      phoneNumberMain = phoneNumberMain.substring(1);
    }

    let phoneNumberText = '';
    switch (format) {
      case CMMHelper.PHONE_NUMBER_FORMATS.PARENTHESES:
        phoneNumberText = `(${phoneNumberMain.substring(0, 3)}) ${phoneNumberMain.substring(
          3,
          6,
        )}-${phoneNumberMain.substring(6)}`;
        break;
      case CMMHelper.PHONE_NUMBER_FORMATS.HYPHENS:
        phoneNumberText = `${phoneNumberMain.substring(0, 3)}-${phoneNumberMain.substring(
          3,
          6,
        )}-${phoneNumberMain.substring(6)}`;
        break;
      case CMMHelper.PHONE_NUMBER_FORMATS.PERIODS:
        phoneNumberText = `${phoneNumberMain.substring(0, 3)}.${phoneNumberMain.substring(
          3,
          6,
        )}.${phoneNumberMain.substring(6)}`;
        break;
    }

    return {
      link: `+1${phoneNumberMain}${phoneNumberExtension ? `,${phoneNumberExtension}` : ''}`,
      text:
        phoneNumberText +
        (phoneNumberExtension ? `, ext. ${phoneNumberExtension}` : ''),
    };
  }
}

// ConvertBoost V2
type ConvertBoostButtonOptions = {
  label: string;
  icon: {
    content: CmmIcon | (string & {});
    color?: string;
  };
  text?: {
    content: string;
    color?: string;
    size?: string;
  };
  classname?: string[];
  action:
    | {
        click: 'modal' | 'chat' | ((ev: MouseEvent) => void);
        link?: never;
        target?: never;
      }
    | {
        click?: never;
        link: string;
        target?: string;
      };
};
type ConvertBoostModalOptions = ModalOptions;
type ConvertBoostOptions = {
  buttons: ConvertBoostButtonOptions[];
  modal?: ConvertBoostModalOptions;
};
class CMMConvertBoost {
  static ButtonFloating = class {
    static readonly Presets = {
      DIRECTIONS: (
        options: WithRequired<Partial<ConvertBoostButtonOptions>, 'action'>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.MAP_PIN,
            },
            label: 'Get Directions',
            action: {
              link: '',
              target: '',
            },
          },
          options,
        ),
      DIRECTIONS_SHOW_LOCATIONS: (
        options: Partial<ConvertBoostButtonOptions>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.MAP_PIN,
            },
            label: 'Get Directions',
            action: {
              click: CMMButtonAction.OPEN_SANITY_LOCATIONS,
            },
          },
          options,
        ),
      DIRECTIONS_OPEN_CONVERTBOOST: (
        options: Partial<ConvertBoostButtonOptions>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.MAP_PIN,
            },
            label: 'See More Options for Directions',
            action: {
              click: CMMButtonAction.OPEN_CONVERTBOOST_MODAL,
            },
          },
          options,
        ),
      PHONE: (
        options: WithRequired<Partial<ConvertBoostButtonOptions>, 'action'>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.PHONE,
            },
            label: 'Call Us',
            action: {
              link: '',
            },
          },
          options,
        ),
      PHONE_SHOW_LOCATIONS: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.PHONE,
            },
            label: 'Call Us',
            action: {
              click: CMMButtonAction.OPEN_SANITY_LOCATIONS,
            },
          },
          options,
        ),
      PHONE_OPEN_CONVERTBOOST: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.PHONE,
            },
            label: 'See More Options to Call Us',
            action: {
              click: CMMButtonAction.OPEN_CONVERTBOOST_MODAL,
            },
          },
          options,
        ),
      SMS: (
        options: WithRequired<Partial<ConvertBoostButtonOptions>, 'action'>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.FA_MESSAGE_SMS,
            },
            label: 'Text Us',
            action: {
              link: '',
            },
          },
          options,
        ),
      SMS_OPEN_CONVERTBOOST: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.FA_MESSAGE_SMS,
            },
            label: 'See More Options to Text Us',
            action: {
              click: CMMButtonAction.OPEN_CONVERTBOOST_MODAL,
            },
          },
          options,
        ),
      CONTACT: (
        options: WithRequired<Partial<ConvertBoostButtonOptions>, 'action'>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.EMAIL,
            },
            label: 'Send Us a Message',
            action: {
              link: '',
            },
          },
          options,
        ),
      CONTACT_HD: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.EMAIL,
            },
            label: 'Send Us a Message',
            action: {
              link: '/contact-us',
            },
          },
          options,
        ),
      CONSULTATION: (
        options: WithRequired<Partial<ConvertBoostButtonOptions>, 'action'>,
      ) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.EMAIL,
            },
            label: 'Send Us a Message',
            action: {
              link: '',
            },
          },
          options,
        ),
      CONSULTATION_HD: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.EMAIL,
            },
            label: 'Request Consultation',
            action: {
              link: '/request-consultation',
            },
          },
          options,
        ),
      CHAT: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.FA_MESSAGE_DOTS,
            },
            label: 'Chat With Us',
            action: {
              click: CMMButtonAction.OPEN_CHAT,
            },
          },
          options,
        ),
      MODAL: (options: Partial<ConvertBoostButtonOptions>) =>
        Object.assign<
          ConvertBoostButtonOptions,
          Partial<ConvertBoostButtonOptions>
        >(
          {
            icon: {
              content: CMMGraphic.ELLIPSIS,
            },
            label: 'See More Options',
            action: {
              click: CMMButtonAction.OPEN_CONVERTBOOST_MODAL,
            },
          },
          options,
        ),
    };
  };

  static Modal = class {
    static readonly Presets = {
      Default: (
        options: WithRequired<Partial<ConvertBoostModalOptions>, 'buttons'>,
      ) =>
        Object.assign<
          ConvertBoostModalOptions,
          Partial<ConvertBoostModalOptions>
        >(
          {
            logo_url: CMMConvertBoost.getWebsiteLogo(),
            description_text: 'Contact us today!',
            footer_text: 'Your Local Experts',
            footer_color: 'transparent',
            show_blocker: false,
            show_pointer: false,
            font: {
              family: 'AUTO',
            },
            buttons: [],
          },
          options,
        ),
    };
  };

  static ButtonModal = class {
    static readonly Presets = {
      CONTACT: (
        options: WithRequired<Partial<ModalButtonHTMLOptions>, 'link'>,
      ) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.EMAIL,
            title: 'Contact Us',
            link: '',
          },
          options,
        ),
      CONTACT_HD: (options: Partial<ModalButtonHTMLOptions>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.EMAIL,
            title: 'Contact Us',
            link: '/contact-us',
          },
          options,
        ),
      CONSULTATION: (
        options: WithRequired<Partial<ModalButtonHTMLOptions>, 'link'>,
      ) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.EMAIL,
            title: 'Free Consultation',
            link: '',
          },
          options,
        ),
      CONSULTATION_HD: (options: Partial<ModalButtonHTMLOptions>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.EMAIL,
            title: 'Free Consultation',
            link: '/request-consultation',
          },
          options,
        ),
      DIRECTIONS: (
        options: WithRequired<Partial<ModalButtonHTMLOptions>, 'link'>,
      ) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.MAP_PIN,
            title: 'Get Directions',
            link: '',
            link_target: '_blank',
          },
          options,
        ),
      DIRECTIONS_SHOW_LOCATIONS: (options: Partial<ModalButtonHTMLOptions>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.MAP_PIN,
            title: 'Get Directions',
            action: CMMButtonAction.OPEN_SANITY_LOCATIONS,
          },
          options,
        ),
      PHONE: (options: WithRequired<Partial<ModalButtonHTMLOptions>, 'link'>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.PHONE,
            title: 'Call Us',
            link: '',
          },
          Object.assign(
            { description: CMMHelper.formatPhoneNumber(options.link).text },
            options,
          ),
        ),
      PHONE_SHOW_LOCATIONS: (options: Partial<ModalButtonHTMLOptions>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.PHONE,
            title: 'Call Us',
            action: CMMButtonAction.OPEN_SANITY_LOCATIONS,
          },
          options,
        ),
      SMS: (options: WithRequired<Partial<ModalButtonHTMLOptions>, 'link'>) =>
        Object.assign<ModalButtonHTMLOptions, Partial<ModalButtonHTMLOptions>>(
          {
            icon: CMMGraphic.FA_MESSAGE_SMS,
            title: 'Text Us',
            link: '',
          },
          Object.assign(
            { description: CMMHelper.formatPhoneNumber(options.link).text },
            options,
          ),
        ),
    };
  };

  private widgetConvertBoost: HTMLElement;

  // scroll hiding
  private scrollLastKnownPosition = 0;
  private scrollDebounce = false;

  constructor() {
    this.widgetConvertBoost = document.createElement('cmm-convertboost');

    document.body.append(this.widgetConvertBoost);
  }

  static async make(options: ConvertBoostOptions) {
    return await new CMMConvertBoost().initializeWidget(options);
  }

  private async initializeWidget(options: ConvertBoostOptions) {
    // setup auto font family
    const fontFamily = window.getComputedStyle(
      document.querySelector('#dmStyle_innerContainer') ?? document.body,
    ).fontFamily;
    this.widgetConvertBoost.style.fontFamily = fontFamily;

    this.setupBodyEndHiding();

    this.setupFooterBannerOffset();

    await this.initializeModal(options.modal);

    this.initializeButtons(options.buttons);

    this.initializeTracking();

    setTimeout(() => {
      this.rePositionWidgetBottom();
    }, 100);
  }

  private async initializeModal(modal?: ConvertBoostModalOptions) {
    if (!modal) return;

    if (modal.classname) {
      modal.classname.push('convertboost-v2-modal');
    } else {
      modal.classname = ['convertboost-v2-modal'];
    }

    modal.display_style = 'tooltip';
    modal.show_blocker = false;
    modal.show_pointer = false;

    await cmmSetupModal(modal);
  }

  private initializeButtons(buttons: ConvertBoostButtonOptions[]) {
    buttons.forEach((buttonOptions) => {
      this.addButton(buttonOptions);
    });
  }

  private initializeTracking() {
    cmmSetupEventTracking([
      {
        selector: [
          'cmm-convertboost a',
          `cmm-convertboost button:not(${['.convertboost-button-modal', '.convertboost-button-chat'].join(',')})`,
        ].join(', '),
        action: (elem) => `ConvertBoost© Floating Button - ${elem.title}`,
        ga4Event: 'cmm_convertboost',
      },
      {
        selector: 'cmm-convertboost button.convertboost-button-modal',
        action: () => {
          //action text indicates if the modal will close or open
          let action = 'ConvertBoost© Modal ';
          if (
            document
              .querySelector('#cmm-call-to-action-modal')
              .classList.contains('cmm-modal-open')
          ) {
            action += 'Close';
          } else {
            action += 'Open';
          }
          return action;
        },
        ga4Event: 'cmm_convertboost',
      },
      {
        selector: 'cmm-convertboost button.convertboost-button-chat',
        action: 'ConvertBoost© Chat Open',
        ga4Event: 'cmm_convertboost',
      },
    ]);
  }

  private setupBodyEndHiding() {
    window.addEventListener('scroll', () => {
      this.scrollLastKnownPosition =
        window.scrollY + window.innerHeight - document.body.scrollHeight;

      if (this.scrollDebounce) {
        return;
      }

      window.requestAnimationFrame(() => {
        if (this.scrollLastKnownPosition < -100) {
          this.show();
        } else {
          this.hide();
        }

        this.scrollDebounce = false;
      });

      this.scrollDebounce = true;
    });
  }

  public rePositionWidgetBottom() {
    const floatingBanner = document.querySelector(
      [
        '.cmm-banner--floating',
        '.showing-message.showing-message--bottom #d-notification-bar',
      ].join(', '),
    );
    if (!floatingBanner) {
      this.widgetConvertBoost.style.removeProperty('--offset-bottom');
      return;
    }

    this.widgetConvertBoost.style.setProperty(
      '--offset-bottom',
      `${floatingBanner.clientHeight}px`,
    );
  }

  private setupFooterBannerOffset() {
    window.addEventListener('resize', () => {
      this.rePositionWidgetBottom();
    });
  }

  public hide() {
    this.widgetConvertBoost.style.setProperty(
      '--offset-bottom-hidden',
      '-80px',
    );
    this.widgetConvertBoost.style.setProperty('--offset-left-hidden', '-80px');
  }

  public show() {
    this.widgetConvertBoost.style.removeProperty('--offset-bottom-hidden');
    this.widgetConvertBoost.style.removeProperty('--offset-left-hidden');
  }

  public addButton(options: ConvertBoostButtonOptions) {
    let button: HTMLAnchorElement | HTMLButtonElement;

    if (options.action.click) {
      button = document.createElement('button');
      button.type = 'button';

      if (
        options.action.click === CMMButtonAction.OPEN_CONVERTBOOST_MODAL ||
        options.action.click === 'modal'
      ) {
        button.classList.add('convertboost-button-modal');

        // open modal on button click if it exists
        button.addEventListener('click', () => {
          CMMButtonAction.OPEN_CONVERTBOOST_MODAL();
        });
      } else if (
        options.action.click === CMMButtonAction.OPEN_CHAT ||
        options.action.click === 'chat'
      ) {
        button.classList.add('convertboost-button-chat');

        // inject styles to hide chat buttons
        const styleElem = document.createElement('style');
        styleElem.innerHTML =
          '[id^="bf-revz-widget"] #bewebchat { pointer-events: none !important; opacity: 0 !important; }';
        document.head.append(styleElem);

        button.addEventListener('click', () => {
          CMMButtonAction.OPEN_CHAT();
        });
      } else {
        button.addEventListener('click', options.action.click);
      }
    } else {
      button = document.createElement('a');
      button.href = options.action.link;
      button.target = options.action.target ?? '_self';
    }

    button.title = options.label;
    button.ariaLabel = options.label;

    if (options.classname?.length) {
      button.classList.add(...options.classname);
    }

    const contentWrapper = document.createElement('div');
    contentWrapper.ariaHidden = 'true';
    contentWrapper.innerHTML =
      CMM_ICON[options.icon.content] ?? options.icon.content;

    if (options.icon.color) {
      (contentWrapper.children[0] as HTMLElement).style.setProperty(
        '--icon-color',
        options.icon.color,
      );
    }

    if (options.text) {
      const textElem = document.createElement('span');
      textElem.innerHTML = options.text.content;

      if (options.text.color) {
        textElem.style.setProperty('--text-color', options.text.color);
      }

      if (options.text.size) {
        textElem.style.setProperty('--font-size', options.text.size);
      }

      contentWrapper.append(textElem);
    }

    button.append(contentWrapper);
    this.widgetConvertBoost.append(button);
  }

  static getWebsiteLogo(): string {
    // TODO: Get other platforms as well
    return '';
  }
}

/**
 * Insert HTML Function
 */
type InsertMode = 'append' | 'prepend' | 'before' | 'after';
function cmmInsertHtml(
  html: string,
  selector: string | string[] | HTMLElement = null,
  insertMode: InsertMode | boolean = 'append',
): Promise<HTMLElement[]> {
  return new Promise((resolve, reject) => {
    function cmmInsertNewElement(
      newHtml: string,
      elementSelector: string | string[] | HTMLElement = null,
      selectInsertMode: string | boolean = 'append',
    ) {
      let tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;

      let appendingElement = document.body;

      if (elementSelector) {
        if (Array.isArray(elementSelector)) {
          // find any HTMLElement in the array of selectors
          appendingElement =
            document.querySelector(
              elementSelector.find((sel) => {
                return document.querySelector(sel);
              }),
            ) ?? appendingElement;
        } else if (elementSelector instanceof HTMLElement) {
          appendingElement = elementSelector;
        } else {
          appendingElement = document.querySelector(elementSelector);
          if (!appendingElement) return;
        }
      }

      let addedElements: HTMLElement[] = [];
      for (let i = tempDiv.childNodes.length - 1; i > -1; i--) {
        if (selectInsertMode === 'append' || selectInsertMode === true) {
          addedElements.push(
            appendingElement.appendChild<HTMLElement>(
              tempDiv.childNodes[i] as HTMLElement,
            ),
          );
        } else if (selectInsertMode === 'before') {
          addedElements.push(
            appendingElement.parentElement.insertBefore<HTMLElement>(
              tempDiv.childNodes[i] as HTMLElement,
              appendingElement,
            ),
          );
        } else if (selectInsertMode === 'after') {
          addedElements.push(
            appendingElement.parentElement.insertBefore<HTMLElement>(
              tempDiv.childNodes[i] as HTMLElement,
              appendingElement.nextSibling,
            ),
          );
        } else if (
          selectInsertMode === 'prepend' ||
          selectInsertMode === false
        ) {
          addedElements.push(
            appendingElement.insertBefore<HTMLElement>(
              tempDiv.childNodes[i] as HTMLElement,
              appendingElement.firstChild,
            ),
          );
        }
      }

      resolve(addedElements);
    }

    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      // call on next available tick
      setTimeout(() => {
        cmmInsertNewElement(html, selector, insertMode);
      }, 1);
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        cmmInsertNewElement(html, selector, insertMode);
      });
    }
  });
}

/**
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 *
 * END HD SCRIPT COPYING - CONVERT TO SCRIPT GENERATION FUNCTION
 *
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 * =========================================================================================
 */

/**
 * =============================================
 * Google Ads
 * =============================================
 */
/** */
interface IterableWithForEach<T> extends Iterable<T> {
  forEach(callback: (value: T) => void): void;
}
type CMMGoogleAdObject = {
  account: string;
  enhanced_conversions?: boolean;
  conversions: CMMGoogleAdConversion[];
};
type CMMGoogleAdConversion = {
  label: string;
  value?: number;
  currency?: string;
} & (
  | {
      selector:
        | 'form_submission'
        | 'internal_form_submission'
        | (string & {})
        | IterableWithForEach<HTMLElement | Document>;
      trigger: string;
      enhancedConversionMapping?: {
        email_field: string[];
        phone_field?: string[];
      };
    }
  | {
      adConversionType: never; //CMMAdConversionType;
    }
  | {
      phoneConversionNumber: string;
      onclickConversion?: boolean;
    }
  | {
      /** strPath of the page to fire conversion on */
      pageload: string;
    }
  | {
      chatWidget: 'chekkit' | 'interactions';
    }
);
type CMMInternalSiteFormFieldData = {
  name: string;
  value: string;
};
declare var enhanced_conversion_data: {
  email?: string;
  phone_number?: string;
};
var cmmLoadingGoogleAdsConversionsScript = false;
var cmmDeferredLoadGoogleAdsConversions = [];
function _process_loadGoogleAdsConversions(
  adObject: CMMGoogleAdObject,
  parentElement: HTMLElement | Document = document,
): void {
  // Check if gtag function exists, otherwise load it then re-run the conversion script
  if (!window.gtag) {
    cmmDeferredLoadGoogleAdsConversions.push(adObject);

    // Exit if already loading the Adwords gtag script
    if (cmmLoadingGoogleAdsConversionsScript) return;
    cmmLoadingGoogleAdsConversionsScript = true;

    loadScriptCMM(
      `https://www.googletagmanager.com/gtag/js`,
      `id=${adObject.account}`,
      {
        async: true,
      },
    ).then((_) => {
      window.gtag =
        window.gtag ||
        function () {
          dataLayer.push(arguments);
        };
      gtag('js', new Date());
      cmmDeferredLoadGoogleAdsConversions.forEach((adObj) =>
        _process_loadGoogleAdsConversions(adObj),
      );
    });
    return;
  }

  // along with the fix below for google-wcc-debug, we need
  // to add phone_conversion_number to the Google Ads config
  // before loading the main Google Ads config
  adObject.conversions.forEach((conversion) => {
    if (!('phoneConversionNumber' in conversion)) {
      return;
    }

    if (conversion.onclickConversion) {
      return;
    }

    gtag('config', `${adObject.account}/${conversion.label}`, {
      phone_conversion_number: conversion.phoneConversionNumber,
      cmm_platform: true,
    });
  });

  // This fixes an issue where #google-wcc-debug didn't load
  // and call tracking stopped
  (window as any).google_tag_manager.ads_pageview = { _gcl: false };

  // This code might be an alternative for tracking calls found on this page:
  // https://support.google.com/google-ads/answer/7548399?hl=en

  // gtag('set', {
  //   phone_conversion_number: '(859) 309-5987',
  //   phone_conversion_ids: ['AW-343469663/RFUsCMnvstkDEN_c46MB'],
  //   phone_conversion_country_code: 'US',
  // });

  // setup initial Google Ads config
  if (
    !dataLayer.some(
      (data) => data[0] === 'config' && data[1] === adObject.account,
    )
  ) {
    if (adObject.enhanced_conversions) {
      gtag('config', adObject.account, { allow_enhanced_conversions: true });
    } else {
      gtag('config', adObject.account);
    }
  }

  adObject.conversions.forEach((conversion) => {
    let conversionData: Partial<CMMGoogleAdConversion> & { send_to: string } = {
      send_to: adObject.account + '/' + conversion.label,
    };
    if (conversion.value || conversion.value === 0) {
      conversionData.value = conversion.value;
      conversionData.currency = conversion.currency || 'USD';
    }

    if ('adConversionType' in conversion) {
      // Only in HD sites
    } else if ('phoneConversionNumber' in conversion) {
      if (conversion.onclickConversion) {
        let simpleNumber = conversion.phoneConversionNumber.replaceAll(
          /[.\s\(\)\-]/g,
          '',
        );
        parentElement
          .querySelectorAll(`[href^="tel:"][href*="${simpleNumber}"]`)
          .forEach((elem: HTMLLinkElement) => {
            elem.onclick = () => {
              gtag('event', 'conversion', {
                send_to: `${adObject.account}/${conversion.label}`,
                event_callback: () => {
                  window.location.href = elem.href;
                },
              });
              return false;
            };
          });
      }
    } else if ('pageload' in conversion) {
      if (conversion.pageload === strPath) {
        gtag('event', 'conversion', conversionData);
      }
    } else if ('chatWidget' in conversion) {
      let chatConversionHandler: (e: MessageEvent<any>) => boolean;

      if (conversion.chatWidget === 'chekkit') {
        chatConversionHandler = (e) => {
          let windowName = '';

          try {
            windowName = (e.source as Window).name;
          } catch (err) {}

          if (windowName !== 'chekkit-frame') return;

          if (e.data !== 'show chat') return;

          return true;
        };
      } else if (conversion.chatWidget === 'interactions') {
        chatConversionHandler = (e) => {
          if (e.origin !== 'https://webchat.birdeye.com') return;

          if (typeof e.data !== 'string') return;

          let jsonData = e.data.split('***')[1];
          let parsedData: {
            sectionName: string;
            actionName: string;
          };
          try {
            parsedData = JSON.parse(jsonData);
          } catch (err) {}
          if (!parsedData) return;

          if (
            parsedData.sectionName !== 'webchat' ||
            parsedData.actionName !== 'send'
          )
            return;

          return true;
        };
      }

      // if no chat widget name matched, exit (don't add event listener)
      if (!chatConversionHandler) return;

      window.addEventListener('message', (e) => {
        if (!chatConversionHandler(e)) return;

        gtag('event', 'conversion', conversionData);
      });
    } else {
      if (conversion.selector === 'form_submission') {
        //TODO: Add form submission mutation listener THEN gtag conversion
        var targetNodes = parentElement.querySelectorAll('form');
        var config = { attributes: true };
        var callback = (mutationsList: any[], observer: MutationObserver) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName.toLowerCase() === 'class'
            ) {
              if (
                mutation.target.className
                  .split(' ')
                  .indexOf('container--show-message') > -1
              ) {
                //form submitted
                gtag('event', 'conversion', conversionData);
              }
            }
          });
        };

        let observer = new MutationObserver(callback);
        targetNodes.forEach((elem) => {
          if (
            conversion.trigger == 'all' ||
            (conversion.trigger == 'lead' &&
              elem.getAttribute('action') &&
              (elem.getAttribute('action').includes('contact-form') ||
                elem
                  .getAttribute('action')
                  .includes('request-consultation-form'))) ||
            (conversion.trigger == 'newsletter' &&
              elem.getAttribute('action') &&
              (elem.getAttribute('action').includes('footer') ||
                elem.getAttribute('action').includes('email-popup')))
          ) {
            observer.observe(elem.parentNode, config);
          }
        });
      } else if (conversion.selector === 'internal_form_submission') {
        if (conversion.trigger === 'all') {
          dmAPI.subscribeEvent(
            dmAPI.EVENTS.FORM_SUBMISSION,
            (data: CMMInternalSiteFormFieldData[]) => {
              // Create enhanced conversion data (if applicable)
              if (
                adObject.enhanced_conversions &&
                conversion.enhancedConversionMapping
              ) {
                let email = data.find((field) => {
                  let fieldLowerCase = field.name.toLowerCase();
                  return conversion.enhancedConversionMapping.email_field.some(
                    (em) => em === fieldLowerCase,
                  );
                })?.value;
                let phone = data.find((field) => {
                  let fieldLowerCase = field.name.toLowerCase();
                  return conversion.enhancedConversionMapping.phone_field.some(
                    (ph) => ph === fieldLowerCase,
                  );
                })?.value;

                if (email) {
                  window.enhanced_conversion_data =
                    window.enhanced_conversion_data ?? {};
                  window.enhanced_conversion_data.email = email;
                }
                if (phone) {
                  window.enhanced_conversion_data =
                    window.enhanced_conversion_data ?? {};
                  window.enhanced_conversion_data.phone_number = phone;
                }
              }

              gtag('event', 'conversion', conversionData);
            },
          );
        } else {
          // TODO: Setup Duda listener for specific forms/form names
        }
      } else {
        let selectedElements: IterableWithForEach<HTMLElement | Document>;
        if (typeof conversion.selector === 'string') {
          selectedElements = parentElement.querySelectorAll<HTMLElement>(
            conversion.selector,
          );
        } else {
          selectedElements = conversion.selector;
        }
        selectedElements.forEach((qElem) => {
          qElem.addEventListener(conversion.trigger, () => {
            gtag('event', 'conversion', conversionData);
          });
        });
      }
    }
  });
}

function createAjaxPageLoadListeners(adObject: CMMGoogleAdObject) {
  // create AdObject for ajax page load listeners
  // FIXME: Doesn't like "document" as a conversion selector
  const listenerAdObject: CMMGoogleAdObject = JSON.parse(
    JSON.stringify(adObject),
  );

  listenerAdObject.conversions = listenerAdObject.conversions.filter(
    (conversion) => {
      if ('phoneConversionNumber' in conversion) {
        return true;
      } else if ('pageload' in conversion) {
        return true;
      } else if ('selector' in conversion) {
        return (
          conversion.selector !== 'internal_form_submission' &&
          conversion.selector !== 'form_submission' &&
          typeof conversion.selector === 'string'
        );
      }

      return false;
    },
  );

  return listenerAdObject;
}

/**
 * Load Google Ads
 */
function loadGoogleAdsConversions(adObject: CMMGoogleAdObject): void {
  _process_loadGoogleAdsConversions(adObject);

  if (cmmGetGenerator() === CMM_GENERATOR_WIX) {
    const listenerAdObject = createAjaxPageLoadListeners(adObject);

    window.addEventListener(
      'cmm-wix-pageview',
      (e: CustomEvent<CMM_WIX_PAGEVIEW_EVENT>) => {
        if (!e.detail.pageContainer) return;

        _process_loadGoogleAdsConversions(
          listenerAdObject,
          e.detail.pageContainer,
        );
      },
    );
  }
}
/** @deprecated Use `loadGoogleAdsConversions` function */
function loadAdwordsConversions(adObject: CMMGoogleAdObject): void {
  loadGoogleAdsConversions(adObject);
}

/**
 * =============================================================
 *    Microsoft Ads
 * =============================================================
 */
/** */
type CMMMicrosoftAdObject = {
  tag_id: string;
  conversions: CMMMicrosoftAdConversion[];
};
type CMMMicrosoftAdConversion = {
  action: string | ((elem: HTMLElement) => string);
  label: string | ((elem: HTMLElement) => string);
  category?: string | ((elem: HTMLElement) => string);
  value?: number | ((elem: HTMLElement) => number);
  currency?: string;
} & (
  | {
      selector: 'form_submission' | 'internal_form_submission' | (string & {});
      trigger: string;
      enhancedConversionMapping?: {
        email_field: string[];
        phone_field?: string[];
      };
    }
  | {
      adConversionType: never; //CMMAdConversionType;
    }
  | {
      phoneConversionNumber: string;
      onclickConversion?: boolean;
    }
  | {
      /** strPath of the page to fire conversion on */
      pageload: string;
    }
  | {
      chatWidget: 'chekkit' | 'interactions';
    }
);
type CMMMicrosoftAdConversionData = {
  event_category?: string;
  event_label?: string;
  event_value?: number;
};
declare var uetq: any[];
declare var UET: any;
/**
 *
 */
function _loadMicrosoftAdsDynamicData(
  selectedElement: HTMLElement,
  conversionSetup: CMMMicrosoftAdConversion,
): { conversionAction: string; conversionData: CMMMicrosoftAdConversionData } {
  let conversionAction: string;
  let conversionData: CMMMicrosoftAdConversionData = {};

  if (typeof conversionSetup.action === 'string') {
    conversionAction = conversionSetup.action;
  } else {
    conversionAction = conversionSetup.action(selectedElement);
  }

  if (conversionSetup.category) {
    if (typeof conversionSetup.category === 'string') {
      conversionData.event_category = conversionSetup.category;
    } else {
      conversionData.event_category = conversionSetup.category(selectedElement);
    }
  }

  if (typeof conversionSetup.label === 'string') {
    conversionData.event_label = conversionSetup.label;
  } else {
    conversionData.event_label = conversionSetup.label(selectedElement);
  }

  if (conversionSetup.value) {
    if (typeof conversionSetup.value === 'number') {
      conversionData.event_value = conversionSetup.value;
    } else {
      conversionData.event_value = conversionSetup.value(selectedElement);
    }
  }

  return {
    conversionAction: conversionAction,
    conversionData: conversionData,
  };
}
/**
 *
 */
function _process_loadMicrosoftAdsConversions(
  adObject: CMMMicrosoftAdObject,
  parentElement: HTMLElement | Document = document,
) {
  // https://help.ads.microsoft.com/#apex/ads/en/56913/2

  // Check if uet function exists, otherwise load it then re-run the conversion script
  if (!window.uetq) {
    loadScriptCMM('//bat.bing.com/bat.js').then(() => {
      var o: any = { ti: adObject.tag_id, enableAutoSpaTracking: true };
      o.q = window.uetq;
      window.uetq = new UET(o);
      window.uetq.push('pageLoad');
    });
  }

  adObject.conversions.forEach((conversion) => {
    if ('adConversionType' in conversion) {
      // Only in HD sites
    } else if ('phoneConversionNumber' in conversion) {
      // TODO: Track phone numbers if needed in E.164 standard (+15558881234)
    } else if ('pageload' in conversion) {
      if (conversion.pageload === strPath) {
        let { conversionAction, conversionData } = _loadMicrosoftAdsDynamicData(
          document.body,
          conversion,
        );
        window.uetq.push('event', conversionAction, conversionData);
      }
    } else if ('chatWidget' in conversion) {
      let chatConversionHandler: (e: MessageEvent<any>) => boolean;

      if (conversion.chatWidget === 'chekkit') {
        chatConversionHandler = (e) => {
          let windowName = '';

          try {
            windowName = (e.source as Window).name;
          } catch (err) {}

          if (windowName !== 'chekkit-frame') return;

          if (e.data !== 'show chat') return;

          return true;
        };
      } else if (conversion.chatWidget === 'interactions') {
        chatConversionHandler = (e) => {
          if (e.origin !== 'https://webchat.birdeye.com') return;

          if (typeof e.data !== 'string') return;

          let jsonData = e.data.split('***')[1];
          let parsedData: {
            sectionName: string;
            actionName: string;
          };
          try {
            parsedData = JSON.parse(jsonData);
          } catch (err) {}
          if (!parsedData) return;

          if (
            parsedData.sectionName !== 'webchat' ||
            parsedData.actionName !== 'send'
          )
            return;

          return true;
        };
      }

      // if no chat widget name matched, exit (don't add event listener)
      if (!chatConversionHandler) return;

      window.addEventListener('message', (e) => {
        if (!chatConversionHandler(e)) return;

        let { conversionAction, conversionData } = _loadMicrosoftAdsDynamicData(
          document.body,
          conversion,
        );
        window.uetq.push('event', conversionAction, conversionData);
      });
    } else {
      if (conversion.selector === 'form_submission') {
        //TODO: Add form submission mutation listener THEN uet conversion
        var targetNodes = parentElement.querySelectorAll('form');
        var config = { attributes: true };
        var callback: MutationCallback = (mutationsList, observer) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type !== 'attributes' ||
              mutation.attributeName.toLowerCase() !== 'class'
            ) {
              return;
            }

            const mutationTarget = mutation.target as HTMLElement;

            if (
              mutationTarget.className
                .split(' ')
                .indexOf('container--show-message') === -1
            ) {
              return;
            }

            //form submitted
            let { conversionAction, conversionData } =
              _loadMicrosoftAdsDynamicData(mutationTarget, conversion);
            window.uetq.push('event', conversionAction, conversionData);
          });
        };

        let observer = new MutationObserver(callback);
        targetNodes.forEach((elem) => {
          if (
            conversion.trigger == 'all' ||
            (conversion.trigger == 'lead' &&
              elem.getAttribute('action') &&
              (elem.getAttribute('action').includes('contact-form') ||
                elem
                  .getAttribute('action')
                  .includes('request-consultation-form'))) ||
            (conversion.trigger == 'newsletter' &&
              elem.getAttribute('action') &&
              (elem.getAttribute('action').includes('footer') ||
                elem.getAttribute('action').includes('email-popup')))
          ) {
            observer.observe(elem.parentNode, config);
          }
        });
      } else if (conversion.selector === 'internal_form_submission') {
        if (conversion.trigger === 'all') {
          dmAPI.subscribeEvent(
            dmAPI.EVENTS.FORM_SUBMISSION,
            (data: CMMInternalSiteFormFieldData[]) => {
              // Create enhanced conversion data (if applicable)
              if (conversion.enhancedConversionMapping) {
                let enhancedData: { em?: string; ph?: string } = {};

                let emailFieldValue = data
                  .find((field) => {
                    let fieldLowerCase = field.name.toLowerCase();
                    return conversion.enhancedConversionMapping.email_field.some(
                      (em) => em === fieldLowerCase,
                    );
                  })
                  ?.value?.trim();

                let phoneFieldValue = data
                  .find((field) => {
                    let fieldLowerCase = field.name.toLowerCase();
                    return conversion.enhancedConversionMapping.phone_field.some(
                      (ph) => ph === fieldLowerCase,
                    );
                  })
                  ?.value?.trim();

                if (emailFieldValue) {
                  let emailFieldValueParts = emailFieldValue.split('@');
                  if (emailFieldValueParts.length === 2) {
                    emailFieldValueParts[0] =
                      emailFieldValueParts[0].replaceAll(/\.|\+.*/g, '');
                    enhancedData.em = emailFieldValueParts.join('@');
                  }
                }

                if (phoneFieldValue) {
                  phoneFieldValue = phoneFieldValue.replaceAll(/[^\d]/g, '');
                  if (phoneFieldValue.length === 10) {
                    phoneFieldValue = '+1' + phoneFieldValue;
                  } else if (phoneFieldValue.length === 11) {
                    phoneFieldValue = '+' + phoneFieldValue;
                  }
                  enhancedData.ph = phoneFieldValue;
                }

                if (enhancedData.em || enhancedData.ph) {
                  window.uetq.push('set', { pid: enhancedData });
                }
              }

              let { conversionAction, conversionData } =
                _loadMicrosoftAdsDynamicData(
                  CMM_LAST_INTERNAL_FORM,
                  conversion,
                );
              window.uetq.push('event', conversionAction, conversionData);
            },
          );
        } else {
          // TODO: Setup Duda listener for specific forms/form names
        }
      } else {
        parentElement
          .querySelectorAll<HTMLElement>(conversion.selector)
          .forEach((qElem) => {
            qElem.addEventListener(conversion.trigger, () => {
              let { conversionAction, conversionData } =
                _loadMicrosoftAdsDynamicData(qElem, conversion);
              window.uetq.push('event', conversionAction, conversionData);
            });
          });
      }
    }
  });
}
/**
 * Load Bing Ads
 */
function loadMicrosoftAdsConversions(adObject: CMMMicrosoftAdObject): void {
  _process_loadMicrosoftAdsConversions(adObject);

  // create AdObject for ajax page load listeners
  const listenerAdObject: CMMMicrosoftAdObject = JSON.parse(
    JSON.stringify(adObject),
  );
  listenerAdObject.conversions = listenerAdObject.conversions.filter(
    (conversion) => {
      if ('phoneConversionNumber' in conversion) {
        return true;
      } else if ('pageload' in conversion) {
        return true;
      } else if ('selector' in conversion) {
        return (
          conversion.selector !== 'internal_form_submission' &&
          conversion.selector !== 'form_submission'
        );
      }

      return false;
    },
  );

  if (cmmGetGenerator() === CMM_GENERATOR_WIX) {
    window.addEventListener(
      'cmm-wix-pageview',
      (e: CustomEvent<CMM_WIX_PAGEVIEW_EVENT>) => {
        if (!e.detail.pageContainer) return;

        _process_loadMicrosoftAdsConversions(
          listenerAdObject,
          e.detail.pageContainer,
        );
      },
    );
  }
}

declare var hj: any;
declare var _hjSettings: any;
/**
 * Hotjar loading script
 *
 * @param siteID Hotjar site ID (listed under the client's tracking code script)
 */
function loadHotjarTracking(siteID: number): void {
  if (siteID) {
    // Replace "hjid" in "hjSettings" with this function's siteID if this needs updating
    // @ts-ignore
    (function (h, o, t, j, a, r) {
      h.hj =
        h.hj ||
        function () {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: siteID, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }
}

/**
 * Load a style/CSS file
 */
function loadStyleCMM(url: string, vars: string = '') {
  var args = '';
  if (vars) {
    args = '?' + vars;
  }

  var style = document.createElement('link');
  style.rel = 'stylesheet';
  style.href = url + args;
  document.head.appendChild(style);
}
/**
 * @deprecated Use "loadStyleCMM" instead
 */
function loadStyleGTM(url: string, vars: string = '') {
  return loadStyleCMM(url, vars);
}

/**
 * Loads a script tag onto the page
 *
 * @param url - URL of the script resource
 * @param vars - any URL parameters for the script
 * @param attributes - any additional tag attributes needed (e.g. id, class, data)
 * @param callback - function to execute when the script loads
 */
function loadScriptCMM(
  url: string,
  vars: string = '',
  attributes: { [key: string]: any } = null,
  callback: (...argc: any[]) => any = null,
): Promise<HTMLScriptElement> {
  return new Promise((resolve, reject) => {
    var script = document.createElement('script');

    var args = '';
    if (vars) {
      args = `?${vars}`;
    }

    if (attributes) {
      Object.keys(attributes).forEach((attr) => {
        if (script.hasOwnProperty(attr)) {
          script[attr] = attributes[attr];
        }
        script.setAttribute(attr, attributes[attr]);
      });
    }

    script.onload = () => {
      if (typeof callback === 'function') {
        callback();
      }
      resolve(script);
    };

    script.onerror = () => {
      reject(script);
    };

    script.src = url + args;
    document.head.appendChild(script);

    // Automatically add 'cmm-podium' to body for sites that use Podium
    if (url.includes('connect.podium.com')) {
      document.body.classList.add('cmm-podium');
    }
  });
}
/**
 * @deprecated Use "loadScriptCMM" instead
 */
function loadScriptGTM(
  url: string,
  vars: string = '',
  isAsync = false,
  callback = null,
): Promise<HTMLScriptElement> {
  return loadScriptCMM(url, vars, isAsync ? { async: true } : null, callback);
}

/**
 * Load global style file
 */
loadStyleCMM('https://assets.creekmoremarketing.com/master-gtm.min.css');

/**
 * Gets the site-specific script/style file URL
 */
function getSiteSpecificCodeURL(id: string, filetype: 'js' | 'css'): string {
  return (
    'https://assets.creekmoremarketing.com/' +
    id +
    '/' +
    (filetype === 'js' ? 'main' : 'style') +
    '.min.' +
    filetype
  );
}

declare var siteCMMBizID: string;
const cmmURLParams = new URLSearchParams(window.location.search);
const cmmAllDisabled =
  cmmURLParams.get('cmm-disable') !== null &&
  (cmmURLParams.get('cmm-disable') === '' ||
    cmmURLParams.get('cmm-disable') === '1' ||
    cmmURLParams.get('cmm-disable').toLowerCase() === 'true');
if (!cmmAllDisabled && window.siteCMMBizID?.trim()) {
  loadScriptCMM(getSiteSpecificCodeURL(siteCMMBizID.trim(), 'js'));
  loadStyleCMM(getSiteSpecificCodeURL(siteCMMBizID.trim(), 'css'));
} else if (!cmmAllDisabled && !window.siteCMMBizID?.trim()) {
  //if no specific siteCMMBizID is set, try to load the hostname file (don't display errors)
  const fileURLJS = getSiteSpecificCodeURL(window.location.hostname, 'js');
  const fileURLCSS = getSiteSpecificCodeURL(window.location.hostname, 'css');
  fetch(`${fileURLJS}?file_exists_check=true`, {
    headers: { 'x-preflight': 'preflight' },
  })
    .then((response) => {
      if (
        response.status === 200 ||
        response.status === 301 ||
        response.status === 302
      ) {
        loadScriptCMM(fileURLJS);
        loadStyleCMM(fileURLCSS);
      } else {
        cmmCheckInternal().then((isInternal) => {
          if (isInternal) {
            console.warn(
              'CMM: Site-specific folder/file does not exist:\n',
              fileURLJS,
            );
          }
        });
      }
    })
    .catch((e) => {
      cmmCheckInternal().then((isInternal) => {
        if (isInternal) {
          console.error(
            'CMM: Site-specific folder/file cannot be loaded:\n',
            fileURLJS,
            '\n',
            e,
          );
        }
      });
    });
}

declare var cmm_gtm_ua_code: string;
declare var cmm_extra_tracking_ids: string[];
declare var ga: any;
if (CMM_IS_ANALYTICS_VERSION_4) {
  // GA4 setup and checking internal traffic
  cmmCheckInternal().then((isInternal) => {
    window.gtag =
      window.gtag ||
      function () {
        dataLayer.push(arguments);
      };
    gtag('js', new Date());

    const trackingID =
      window.cmm_gtm_ua_code ?? cmmGetDataLayerGA4Config()?.trackingID ?? '';
    let sendManualPageView = false;
    let sendAutomaticPageView = true;
    const previousGA4Config = cmmGetDataLayerGA4Config(trackingID);
    if (previousGA4Config) {
      if (
        !previousGA4Config.config ||
        previousGA4Config.config.send_page_view === undefined ||
        previousGA4Config.config.send_page_view === true
      ) {
        sendManualPageView = false;
        sendAutomaticPageView = false;
      } else {
        sendManualPageView = true;
        sendAutomaticPageView = false;
      }
    }

    if (!trackingID) return;

    if (isInternal) {
      gtag('set', {
        traffic_type: 'internal',
      });
      gtag('config', trackingID, {
        debug_mode: true,
        send_page_view: sendAutomaticPageView,
      });
    } else {
      gtag('config', trackingID, {
        send_page_view: sendAutomaticPageView,
      });
    }

    if (
      window.cmm_extra_tracking_ids &&
      Array.isArray(window.cmm_extra_tracking_ids)
    ) {
      window.cmm_extra_tracking_ids.forEach((extraTrackingID) => {
        gtag('config', extraTrackingID);
      });
    }

    // send a manual page_view event if gtag not sending automatically
    if (sendManualPageView) {
      gtag('event', 'page_view');
    }
  });
} else if (window.cmm_gtm_ua_code) {
  dataLayer.push({ event: 'cmm.pageview' });
  cmm_log_data({
    message: 'Deprecated UA tracking used',
    severity: CMMLogLevelGTM.WARNING,
    component: 'Google_Analytics',
  });
}

/**
 * Custom Google Analytics tracking
 *
 * NOTE: Only use this function if not other trackers are present on the page
 * and not using `cmm_gtm_ua_code` variable.
 *
 * @param {string} trackingID If not set, this will use the default tracker on the site and NOT fire a pageview event.
 */
function loadGoogleAnalyticsTracking(trackingID?: string) {
  if (trackingID) {
    window.cmm_gtm_ua_code = trackingID;
    dataLayer.push({ event: 'cmm.pageview' });
  } else {
    let trackers = ga.getAll();
    if (trackers.length > 0) {
      let trackingID = trackers[0]?.model?.data?.get('trackingId');
      if (trackingID) window.cmm_gtm_ua_code = trackingID;
    }
  }
}

const CMM_DIRECTIONS_SELECTORS = [
  'a[href*="maps.apple.com"]',
  'a[href^="https://g.page/"]:not([href*="/review"])',
  'a[href*="goo.gl/maps"]',
  'a[href*="maps.google.com"]',
  'a[href*="maps.google.ca"]',
  'a[href*="google.com/maps"]',
  'a[href*="google.ca/maps"]',
  '.sqs-block-content.page-map div[title]',
  '.sqs-block-content.page-map div[title] img',
];

let CMM_LAST_INTERNAL_FORM: HTMLFormElement | null = null;
/**
 * Google Analytics 4 Default Tracking Events
 *
 * Outbound links (maps, mailto, tel, sms, etc.), scrolling,
 * site search, video engagement, and file downloads tracked by default
 */
function cmmSetupGA4DefaultEvents() {
  if (!CMM_IS_ANALYTICS_VERSION_4) return;

  // TODO: Remove when new dashboard released
  const sendOldDashboardEvents = (
    elem: HTMLElement,
    action: string,
    label: string,
  ) => {
    const customAction = elem.dataset.cmmEventAction;
    if (customAction) {
      action = customAction;
    }

    const customLabel = elem.dataset.cmmEventLabel;
    if (customLabel) {
      label = customLabel;
    }

    const data = {
      event_action: action,
      event_label: label,
    };
    gtag('event', 'cmm_event', data);
  };
  document
    .querySelectorAll(
      ['a[href^="tel:"]', '.dmCall.voipReplacement:not(.revealPhoneNum)'].join(
        ',',
      ),
    )
    .forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLAnchorElement;
        sendOldDashboardEvents(target, 'Click to Call', target.href);
      });
    });
  document
    .querySelectorAll(CMM_DIRECTIONS_SELECTORS.join(','))
    .forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const target = e.currentTarget as HTMLAnchorElement;
        sendOldDashboardEvents(
          target,
          'Directions',
          target.href ?? (target as any).src,
        );
      });
    });
  document.querySelectorAll('a[href^="mailto:"]').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLAnchorElement;
      sendOldDashboardEvents(target, 'Click to Email', target.href);
    });
  });
  document.querySelectorAll('a[href$=".pdf"]').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLAnchorElement;
      sendOldDashboardEvents(target, 'PDF Download', target.href);
    });
  });
  document.querySelectorAll('a[href^="sms:"]').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      const target = e.currentTarget as HTMLAnchorElement;
      sendOldDashboardEvents(target, 'Click to Text', target.href);
    });
  });

  cmmScrollTracking([25, 50, 75]); // 90% automatically tracked when setting up GA4 property

  // Detailed parameters
  // https://developers.google.com/analytics/devguides/collection/ga4/reference/events

  // Recommended Events
  // https://support.google.com/analytics/answer/9267735

  // Default Events
  // https://support.google.com/analytics/answer/9216061

  // Automatically collected events
  // https://support.google.com/analytics/answer/9234069

  // Interactions chat started
  window.addEventListener('datalayerpush', (e: DataLayerPushEvent) => {
    if (e.detail.dataLayerObject.event === 'webchatCTATracking') {
      // Interactions chat started

      cmmSendEventData(
        e.detail.dataLayerObject.actionName,
        e.detail.dataLayerObject.actionValue,
        'cmm_interactions',
        null,
        'CMM Interactions',
      );
    } else if (
      e.detail.dataLayerObject.event === 'Webchat Widget' &&
      e.detail.dataLayerObject.eventCategory === 'podium'
    ) {
      // Podium chat started or clicked

      if (e.detail.dataLayerObject.eventAction === 'Bubble Clicked') {
        cmmSendEventData(
          e.detail.dataLayerObject.eventAction,
          e.detail.dataLayerObject.eventCategory,
          'webchat_bubble_clicked',
          null,
        );
      } else if (
        e.detail.dataLayerObject.eventAction === 'Conversation Started'
      ) {
        cmmSendEventData(
          e.detail.dataLayerObject.eventAction,
          e.detail.dataLayerObject.eventCategory,
          'webchat_conversation_started',
          null,
        );
      }
    }
  });

  /**
   * Get the form's name for analytics
   *
   * First try to get the name, then ID, then action, then just the current URL
   */
  const getFormName = (formElement: HTMLFormElement) => {
    // For Duda
    if (cmmGetGenerator() === CMM_GENERATOR_INTERNAL) {
      const formTitle =
        formElement.parentElement.previousElementSibling?.textContent;
      if (formTitle) {
        return formTitle;
      }
    }

    const formName = formElement.name?.trim() || formElement.id?.trim();
    if (formName) {
      return formName;
    }

    const formAction = formElement.getAttribute('action');
    if (formAction) {
      return formAction;
    }

    const formURLIndex = window.location.origin + window.location.pathname;
    return formURLIndex;
  };

  const trackFormSubmission = (
    emailLabel: string,
    formElement: HTMLFormElement,
  ) => {
    if (!formElement) return;

    const formName = getFormName(formElement);

    cmmSendEventData(formName, emailLabel, 'form_submit', {
      form_id: formElement.id,
      form_name: formName,
      form_destination: formElement.action,
      form_submit_text:
        formElement.querySelector<HTMLInputElement>(
          'input[type="submit"], button[type="submit"]',
        )?.value ?? '',
    });
  };

  // Internal CMS tracking events
  if (cmmGetGenerator() === CMM_GENERATOR_INTERNAL) {
    // record last submitted form for tracking purposes later
    document.querySelectorAll('form').forEach((formElem) => {
      formElem.addEventListener(
        'submit',
        (e) => (CMM_LAST_INTERNAL_FORM = e.target as HTMLFormElement),
      );
    });
    new Promise<void>((resolve, reject) => {
      function checkDm() {
        if (window.dmAPI?.EVENTS) {
          resolve();
        } else {
          setTimeout(() => {
            checkDm();
          }, 50);
        }
      }
      checkDm();
    }).then(() => {
      dmAPI.subscribeEvent(
        dmAPI.EVENTS.FORM_SUBMISSION,
        (data: { name: string; value: string }[]) => {
          let emailLabel =
            cmmObfuscateEmail(
              data.find((field) => field.name.toLowerCase().includes('email'))
                ?.value ?? '',
            ) ?? 'Unknown Email';

          trackFormSubmission(emailLabel, CMM_LAST_INTERNAL_FORM);
        },
      );
      dmAPI.subscribeEvent(dmAPI.EVENTS.CLICK_TO_CALL, () => {
        cmmSendEventData(null, null, 'click');
      });
      dmAPI.subscribeEvent(dmAPI.EVENTS.STORE_ORDER, () => {
        // TODO: Need to include ecommerce parameters
        // https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#purchase
        // cmmSendEventData( null, null, 'purchase' );
      });
    });
  }

  /**
   * form_start events
   */
  const listenForFormEvents = (formElem: HTMLFormElement) => {
    // ensure ConstantContact forms aren't listened to twice
    const ctctWrapper = formElem.closest('.ctct-inline-form');
    if (ctctWrapper) {
      // exit if the form is already being listened to
      if (ctctWrapper.getAttribute('cmm-listeners-added')) {
        return;
      }

      ctctWrapper.setAttribute('cmm-listeners-added', 'true');
    }

    // form_start
    formElem.addEventListener('click', (e) => {
      const formElement = e.currentTarget as HTMLFormElement;

      // ensure tracking doesn't happen twice on the same form
      if (formElement.hasAttribute(FORM_ANALYTICS_INTERACTION_ATTRIBUTE))
        return;
      formElement.setAttribute(FORM_ANALYTICS_INTERACTION_ATTRIBUTE, 'true');

      const formName = getFormName(formElement);

      cmmSendEventData(formName, null, 'form_start', {
        form_id: formElement.id,
        form_name: formName,
        form_destination: formElement.action,
      });
    });

    // TODO: Stopping early might cancel CTCT form listening on "internal" sites

    // stop if internal CMS
    if (cmmGetGenerator() == CMM_GENERATOR_INTERNAL) return;

    function formSubmitted(formElement: HTMLFormElement) {
      let formData = new FormData(formElement);

      const BLANK_EMAIL = 'Unknown Email';
      let emailLabel = BLANK_EMAIL;
      [...formData.entries()].forEach((field) => {
        const key = field[0];
        const value = field[1];

        const fieldType = formElement.querySelector<HTMLInputElement>(
          `[name="${key}"]`,
        )?.type;

        if (!key.toLowerCase().includes('email') && fieldType !== 'email') {
          return;
        }
        if (typeof value !== 'string') {
          return;
        }

        emailLabel = cmmObfuscateEmail(value);
        if (!emailLabel.trim()) {
          emailLabel = BLANK_EMAIL;
        }
      });

      trackFormSubmission(emailLabel, formElement);
    }

    // form_submit (non internal CMS)
    if (formElem.classList.contains('elementor-form')) {
      // elementor form submitted
      deferJQuery(() => {
        jQuery(formElem).on('submit_success', (e) => {
          formSubmitted(e.currentTarget as HTMLFormElement);
        });
      });
    } else if (formElem.id.includes('forminator')) {
      // forminator form submitted
      deferJQuery(() => {
        jQuery(formElem).on('forminator:form:submit:success', (e) => {
          formSubmitted(e.target as HTMLFormElement);
        });
      });
    } else {
      formElem.addEventListener('submit', (e) => {
        formSubmitted(e.currentTarget as HTMLFormElement);
      });
    }
  };

  const FORM_ANALYTICS_INTERACTION_ATTRIBUTE = 'analytics-interaction-tracked';
  document.querySelectorAll('form').forEach((formElem) => {
    listenForFormEvents(formElem);
  });

  document.addEventListener('cmm-ctct-form-initialized', (e: CustomEvent) => {
    const ctctForm: HTMLFormElement = e.detail.form;
    if (!ctctForm) return;

    listenForFormEvents(ctctForm);
  });
  document
    .querySelectorAll('.ctct-inline-form')
    .forEach((ctctFormWrapper: HTMLElement) => {
      // exit if form already added (listeners already applied)
      if (ctctFormWrapper.getAttribute('cmm-listeners-added')) return;

      const listenToCTCTForm = (formWrapper: HTMLElement) => {
        const form = formWrapper.querySelector('form');
        if (!form) return null;

        document.dispatchEvent(
          new CustomEvent('cmm-ctct-form-initialized', {
            detail: {
              form: form,
            },
          }),
        );
        return form;
      };

      // exit if form already added and listening to
      if (listenToCTCTForm(ctctFormWrapper)) return;

      // observe changes to CTCT wrapper
      const observer = new MutationObserver((mutationList, observer) => {
        if (listenToCTCTForm(ctctFormWrapper)) {
          observer.disconnect();
          return;
        }
      });
      observer.observe(ctctFormWrapper, { childList: true, subtree: true });
    });

  //CHECK =============
  //check custom event tracking

  cmmSetupEventTracking([
    // Appointment Tracking
    {
      selector: 'a[href*="calendly.com"]',
      action: 'Calendly',
      ga4Event: 'schedule_appointment',
      errorType: 'none',
    },
  ]);
}
cmmSetupGA4DefaultEvents();

/**
 * Load Interactions script (Birdeye)
 *
 * Copied from the AEM/HD script
 */
function loadAmplifyInteractionsScript(scriptUrl: string): void {
  document.body.classList.add('cmm-wti');

  var urlParts = scriptUrl.split('/');
  if (urlParts.length < 9) {
    console.log('Birdeye script malformed');
    return;
  }

  var trackingID = urlParts[7];
  var intDiv = document.createElement('div');
  intDiv.id = 'bf-revz-widget-' + trackingID;
  document.body.appendChild(intDiv);

  var intScript = document.createElement('script');
  intScript.type = 'text/javascript';
  intScript.src = scriptUrl;
  document.head.appendChild(intScript);
}
/**
 * @deprecated Use `loadAmplifyInteractionsScript` instead
 */
function loadInteractionsScript(scriptUrl: string): void {
  loadAmplifyInteractionsScript(scriptUrl);
}

/** TESTING BEGIN */
if (
  document.querySelectorAll('.romw-reviews, div[data-romw-token], .romw-badge')
    .length > 0
) {
  cmm_log_data({
    message: 'ReviewsOnMyWebsite active',
    severity: CMMLogLevelGTM.INFO,
    component: 'Client_Checkup',
  });
}
/** TESTING END */

// Open the CMM Console with Alt+Shift+C (Option+Shift+C) on a client site
// Or open Duda site to page to edit with Alt+Shift+D (Option+Shift+D)
type CMMBusinessURLs = {
  url?: string;
  editor?: string;
};
(async () => {
  cmmIfInternal(() => {
    let loadingData = false;
    let consoleData: CMMBusinessURLs | null = null;

    function addSpinner() {
      let apiSpinnerDiv = document.createElement('div');
      apiSpinnerDiv.classList.add('cmm-api-spinner-blocker');
      apiSpinnerDiv.innerHTML =
        '<div class="cmm-api-blocker-spinner-wrapper"><svg class="cmm-api-blocker-spinner" viewBox="0 0 50 50"><circle class="cmm-api-blocker-spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';
      document.body.append(apiSpinnerDiv);

      return apiSpinnerDiv;
    }

    async function fetchConsoleDomain() {
      if (consoleData) {
        return consoleData;
      }

      // get CMM Console path from API
      let domain = window.location.hostname;
      if (domain.startsWith('www.')) {
        domain = domain.substring(4);
      }

      const path = location.pathname.substring(1);

      // fetch and parse data from API
      const response = await fetch(
        `https://creekmore.marketing/api/console-business-search/domain/${domain}?path=${path}`,
      );

      const data: CMMBusinessURLs = await response.json();

      consoleData = data;

      return data;
    }

    function openNewTab(url: string) {
      window.open(url, '_blank');
    }

    document.addEventListener('keydown', async (e) => {
      // modifier keys not pressed
      if (!(e.shiftKey && e.altKey)) {
        return;
      }

      // C or D not pressed
      if (e.code !== 'KeyC' && e.code !== 'KeyD') {
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      if (loadingData) return;
      loadingData = true;

      // show loading spinner
      const apiSpinnerDiv = addSpinner();

      try {
        const data = await fetchConsoleDomain();

        let url: string;
        switch (e.code) {
          case 'KeyC':
            if (!data.url) throw Error('Console URL not found');
            url = data.url;
            break;
          case 'KeyD':
            if (!data.editor) throw Error('Editor URL not found');
            url = data.editor;
            break;
        }

        if (!url) {
          throw Error('URL not found');
        }

        openNewTab(url);
      } catch (err) {
        console.log(err);
      }

      loadingData = false;
      apiSpinnerDiv.remove();
    });
  });
})();

type CMMPromotionBannerOptions = {
  selector: string;
  brand?: string;
  promo?: string;
  /** @deprecated */
  append?: boolean;
  insertMode?: InsertMode;
  hideBrandLogo?: boolean;
  hideDates?: boolean;
  promoText?: string;
  buttonText?: string;
  buttonLink?: string;
  buttonTarget?: string;
  bannerColor?: string;
  textColor?: string;
  buttonColor?: string;
  buttonTextColor?: string;
  extraStyle?: Partial<CSSStyleDeclaration>;
  classList?: string[];
};

declare var CMMPromotionLoader: {
  FILE_LANGAUGE_FOLDERS: {
    [key: string]: {
      [key: string]: {
        label: string | Record<string, string>;
        linkAsset: string;
        assets: Record<string, any>;
        startShow?: Date;
        start?: Date;
        end?: Date;
      };
    };
  };
  isPromoCurrent: (promoDetails: any) => boolean;
  getLanguageFileLink: (...args: any[]) => string;
  [key: string]: any;
};
var cmmPromotionBannerCount = 0;
async function cmmInsertPromotionBanner(argOptions: CMMPromotionBannerOptions) {
  const options = Object.assign<
    CMMPromotionBannerOptions,
    CMMPromotionBannerOptions
  >(
    {
      brand: 'hunter-douglas',
      promo: 'quarterly',
      insertMode: 'prepend',
      hideBrandLogo: false,
      hideDates: false,
      promoText: null,
      buttonText: 'Learn More',
      buttonTarget: '_self',
      extraStyle: {},
    } as CMMPromotionBannerOptions,
    argOptions,
  );

  if (!options.selector) {
    console.log('Promotion Banner: No selector found');
    return;
  }

  if (!window.CMMPromotionLoader) {
    await loadScriptCMM(
      'https://assets.creekmoremarketing.com/promotions.min.js',
    );
  }

  const promo =
    CMMPromotionLoader.FILE_LANGAUGE_FOLDERS[options.brand][options.promo] ??
    null;
  if (!promo) {
    cmmIfInternal(() => {
      console.log('CMM: Promotion Banner: brand or promo not found.');
    });
    return;
  }

  const showPromo = CMMPromotionLoader.isPromoCurrent(promo);
  if (!showPromo) {
    cmmIfInternal(() => {
      console.log('CMM: Promotion Banner: promotion not current');
    });
    return;
  }

  const bannerClass = [
    'cmm-auto-promo-banner',
    `cmm-auto-promo-banner__${++cmmPromotionBannerCount}`,
    ...(options.classList ?? []),
  ].join(' ');

  let bannerHTML = `<div class="${bannerClass}">`;

  if (!options.hideBrandLogo) {
    const svg =
      '<svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1518 1520" width="100" height="100"><defs><clipPath clipPathUnits="userSpaceOnUse" id="cp1"><path d="m-27.78 0h1605.52v1520.29h-1605.52z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="cp2"><path d="m774.98 767h802.76v753.29h-802.76z"/></clipPath><clipPath clipPathUnits="userSpaceOnUse" id="cp3"><path d="m-27.78 0h802.76v767h-802.76z"/></clipPath></defs><g><g clip-path="url(#cp1)"><g><path fill="transparent" d="m759 1520c-419.6 0-758.8-339.7-758.8-760 0-420.3 339.2-760 758.8-760 419.7 0 758.9 339.7 758.9 760 0 420.3-339.2 760-758.9 760z"/><path fill="currentColor" d="m759 760.1v759.9c-419 0-758.6-340.1-758.6-759.9h758.6v-760.1c419.1 0 758.9 340.4 758.9 760.1z"/></g></g><g clip-path="url(#cp2)"><g><path fill="currentColor" d="m802.6 1518.9c384.3-22 692.2-330.1 713.8-715.1-388.2 72.3-641.6 326.1-713.8 715.1z"/></g></g><g clip-path="url(#cp3)"><g><path fill="currentColor" d="m715.4 1.4c-384.3 21.7-691.9 330.1-713.8 715.1 388.2-72.3 642-326.1 713.8-715.1z"/></g></g></g></svg>';
    bannerHTML += svg;
  }

  let promoContent = '';
  if (options.promoText) {
    promoContent = options.promoText;
  } else {
    promoContent =
      typeof promo.label === 'string'
        ? promo.label
        : (promo.label['en-US'] ?? promo.label.fallback);
  }

  let dateContent = '';
  if (!options.hideDates) {
    if (promo.start && promo.end) {
      const start = promo.start.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
      const end = promo.end.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
      dateContent = `${start} - ${end}`;
    } else if (promo.start) {
      dateContent = `Starts ${promo.start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
    } else if (promo.end) {
      dateContent = `Ends ${promo.end.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
    }
  }

  const bannerContent = [promoContent, dateContent]
    .map((c) => `<span>${c}</span>`)
    .join('<separator></separator>');
  bannerHTML += `<div>${bannerContent}</div>`;

  if (!options.buttonLink) {
    options.buttonLink = CMMPromotionLoader.getLanguageFileLink(
      promo.linkAsset,
      promo,
      false,
      'en-US',
    );
    options.buttonTarget = '_blank';
  }
  bannerHTML += `<a href="${options.buttonLink}" target="${options.buttonTarget}" title="View promotion details">${options.buttonText}</a>`;

  bannerHTML += '</div>';

  // set banner class on body that this banner rendered
  document.body.classList.add('cmm-auto-promo-banner-active');

  // insert banner HTML
  return cmmInsertHtml(
    bannerHTML,
    options.selector,
    options.append ?? options.insertMode,
  ).then((banner) => {
    const addedBanner = banner.at(0);
    if (!addedBanner) return;

    if (options.bannerColor) {
      addedBanner.style.setProperty('--banner-color', options.bannerColor);
    }
    if (options.textColor) {
      addedBanner.style.setProperty('--text-color', options.bannerColor);
    }
    if (options.buttonColor) {
      addedBanner.style.setProperty('--button-color', options.bannerColor);
    }
    if (options.buttonTextColor) {
      addedBanner.style.setProperty('--button-text-color', options.bannerColor);
    }

    Object.assign(addedBanner.style, options.extraStyle);
  });
}

/**
 * Animates a banner object
 *
 * @param carousel `cmm-banner-inner-content--carousel` element
 * @param speed number of seconds between slide changes
 */
function cmmHeaderBannerCarouselSlide(carousel: HTMLElement, speed: number) {
  const transitionSpeed = 1000;

  setTimeout(
    () => {
      carousel.classList.add('cmm-banner-inner-content--carousel-sliding');

      setTimeout(() => {
        const removed = carousel.removeChild(carousel.childNodes[0]);
        carousel.classList.remove('cmm-banner-inner-content--carousel-sliding');
        carousel.appendChild(removed);
      }, transitionSpeed);

      cmmHeaderBannerCarouselSlide(carousel, speed);
    },
    speed * 1000 + transitionSpeed,
  );
}

function cmmGa4OutboundProtocolHandler(
  target: EventTarget,
  outbound: boolean = true,
) {
  const link = target as HTMLLinkElement;

  gtag('event', 'click', {
    link_url: link.href,
    link_id: link.id,
    link_classes: link.className,
    link_domain: new URL(link.href).hostname,
    outbound: outbound,
    transport_type: 'beacon',
  });
}

function cmmGa4DirectEventNames(parentElement: HTMLElement | Document) {
  // calls
  parentElement
    .querySelectorAll(['a[href^="tel:"]'].join(', '))
    .forEach((elem) => {
      elem.addEventListener('click', (event) => {
        cmmGa4OutboundProtocolHandler(event.currentTarget);
      });
    });
  // emails
  parentElement
    .querySelectorAll(['a[href^="mailto:"]'].join(', '))
    .forEach((elem) => {
      elem.addEventListener('click', (event) => {
        cmmGa4OutboundProtocolHandler(event.currentTarget);
      });
    });
  // sms/emails
  parentElement
    .querySelectorAll(['a[href^="sms:"]'].join(', '))
    .forEach((elem) => {
      elem.addEventListener('click', (event) => {
        cmmGa4OutboundProtocolHandler(event.currentTarget);
      });
    });
  // directions
  parentElement
    .querySelectorAll(CMM_DIRECTIONS_SELECTORS.join(','))
    .forEach((elem) => {
      elem.addEventListener('click', (event) => {
        // GA4 Already tracking
        // cmmGa4OutboundProtocolHandler(event.currentTarget);
      });
    });
  // files
  parentElement
    .querySelectorAll(['a[href$=".pdf"]', 'a[href$=".docx"]'].join(', '))
    .forEach((elem) => {
      elem.addEventListener('click', (event) => {
        cmmGa4OutboundProtocolHandler(event.currentTarget, false);
      });
    });
}
cmmGa4DirectEventNames(document);
